(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/*!
 * 
 * ZingTouch v1.0.6
 * Author: ZingChart http://zingchart.com
 * License: MIT
 */
!function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={exports:{},id:r,loaded:!1};return e[r].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}var i=n(1),u=r(i);window.ZingTouch=u.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(2),u=r(i),o=n(4),a=r(o),s=n(10),c=r(s),f=n(12),l=r(f),d=n(13),p=r(d),h=n(14),y=r(h),v=n(15),g=r(v),m=n(16),b=r(m),w={_regions:[],Gesture:a.default,Expand:c.default,Pan:l.default,Pinch:p.default,Rotate:y.default,Swipe:g.default,Tap:b.default,Region:function(e,t,n){var r=w._regions.length,i=new u.default(e,t,n,r);return w._regions.push(i),i}};t.default=w},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(3),a=r(o),s=n(4),c=r(s),f=n(6),l=r(f),d=n(9),p=r(d),h=function(){function e(t,n,r,u){var o=this;i(this,e),this.id=u,this.element=t,this.capture="undefined"!=typeof n&&n,this.preventDefault="undefined"==typeof r||r,this.state=new p.default(u);var a=[];a=window.PointerEvent&&!window.TouchEvent?["pointerdown","pointermove","pointerup"]:["mousedown","mousemove","mouseup","touchstart","touchmove","touchend"],a.map(function(e){t.addEventListener(e,function(e){(0,l.default)(e,o)},o.capture)})}return u(e,[{key:"bind",value:function(e,t,n,r,i){if(!e||e&&!e.tagName)throw"Bind must contain an element";return i="undefined"!=typeof i&&i,t?void this.state.addBinding(e,t,n,r,i):new a.default(e,i,this.state)}},{key:"bindOnce",value:function(e,t,n,r){this.bind(e,t,n,r,!0)}},{key:"unbind",value:function(e,t){var n=this,r=this.state.retrieveBindingsByElement(e),i=[];return r.forEach(function(r){if(t){if("string"==typeof t&&n.state.registeredGestures[t]){var u=n.state.registeredGestures[t];u.id===r.gesture.id&&(e.removeEventListener(r.gesture.getId(),r.handler,r.capture),i.push(r))}}else e.removeEventListener(r.gesture.getId(),r.handler,r.capture),i.push(r)}),i}},{key:"register",value:function(e,t){if("string"!=typeof e)throw new Error("Parameter key is an invalid string");if(!t instanceof c.default)throw new Error("Parameter gesture is an invalid Gesture object");t.setType(e),this.state.registerGesture(t,e)}},{key:"unregister",value:function(e){this.state.bindings.forEach(function(t){t.gesture.getType()===e&&t.element.removeEventListener(t.gesture.getId(),t.handler,t.capture)});var t=this.state.registeredGestures[e];return delete this.state.registeredGestures[e],t}}]),e}();t.default=h},function(e,t){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var r=function e(t,r,i){var u=this;n(this,e),this.element=t,Object.keys(i.registeredGestures).forEach(function(e){u[e]=function(t,n){return i.addBinding(u.element,e,t,n,r),u}})};t.default=r},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(5),a=r(o),s=function(){function e(){i(this,e),this.type=null,this.id=null}return u(e,[{key:"setType",value:function(e){this.type=e}},{key:"getType",value:function(){return this.type}},{key:"setId",value:function(e){this.id=e}},{key:"getId",value:function(){return null!==this.id?this.id:this.type}},{key:"update",value:function(e){for(var t in e)this[t]&&(this[t]=e[t])}},{key:"start",value:function(e,t,n){return null}},{key:"move",value:function(e,t,n){return null}},{key:"end",value:function(e){return null}},{key:"isValid",value:function(e,t,n){var r=!0;return e.length>1&&e.forEach(function(e){a.default.isInside(e.initial.x,e.initial.y,n)||(r=!1)}),r}}]),e}();t.default=s},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=360,r=180,i={normalizeEvent:function(e){switch(e){case"mousedown":case"touchstart":case"pointerdown":return"start";case"mousemove":case"touchmove":case"pointermove":return"move";case"mouseup":case"touchend":case"pointerup":return"end";default:return null}},isWithin:function(e,t,n,r,i){return Math.abs(t-r)<=i&&Math.abs(e-n)<=i},distanceBetweenTwoPoints:function(e,t,n,r){var i=Math.sqrt((t-e)*(t-e)+(r-n)*(r-n));return Math.round(100*i)/100},getMidpoint:function(e,t,n,r){return{x:(e+t)/2,y:(n+r)/2}},getAngle:function(e,t,i,u){var o=Math.atan2(u-t,i-e)*(r/Math.PI);return n-(o<0?n+o:o)},getAngularDistance:function(e,t){var i=(t-e)%n,u=i<0?1:-1;return i=Math.abs(i),i>r?u*(n-i):u*i},getVelocity:function(e,t,n,r,i,u){var o=this.distanceBetweenTwoPoints(e,r,t,i);return o/(u-n)},getRightMostInput:function(e){var t=null,n=Number.MIN_VALUE;return e.forEach(function(e){e.initial.x>n&&(t=e)}),t},isInteger:function(e){return"number"==typeof e&&e%1===0},isInside:function(e,t,n){var r=n.getBoundingClientRect();return e>r.left&&e<r.left+r.width&&t>r.top&&t<r.top+r.height},getPropagationPath:function(e){if(e.path)return e.path;for(var t=[],n=e.target;n!=document;)t.push(n),n=n.parentNode;return t},getPathIndex:function(e,t){var n=e.length;return e.forEach(function(e,r){e===t&&(n=r)}),n},setMSPreventDefault:function(e){e.style["-ms-content-zooming"]="none",e.style["touch-action"]="none"},removeMSPreventDefault:function(e){e.style["-ms-content-zooming"]="",e.style["touch-action"]=""}};t.default=i},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){var n=t.state;if(0!==n.inputs.length||"start"===f.default.normalizeEvent(e.type)){if("undefined"!=typeof e.buttons&&"end"!==f.default.normalizeEvent(e.type)&&0===e.buttons)return void n.resetInputs();if(n.updateInputs(e,t.element)){var r=n.retrieveBindingsByInitialPos();r.length>0&&!function(){t.preventDefault?(f.default.setMSPreventDefault(t.element),e.preventDefault?e.preventDefault():e.returnValue=!1):f.default.removeMSPreventDefault(t.element);var i={},u=(0,s.default)(r,e,n);u.forEach(function(t){var n=t.binding.gesture.id;if(i[n]){var r=f.default.getPropagationPath(e);f.default.getPathIndex(r,t.binding.element)<f.default.getPathIndex(r,i[n].binding.element)&&(i[n]=t)}else i[n]=t}),Object.keys(i).forEach(function(e){var t=i[e];(0,o.default)(t.binding,t.data,t.events)})}();var i=0;n.inputs.forEach(function(e){"end"===e.getCurrentEventType()&&i++}),i===n.inputs.length&&n.resetInputs()}}}Object.defineProperty(t,"__esModule",{value:!0});var u=n(7),o=r(u),a=n(8),s=r(a),c=n(5),f=r(c);t.default=i},function(e,t){"use strict";function n(e,t,n){t.events=n;var i=new CustomEvent(e.gesture.getId(),{detail:t,bubbles:!0,cancelable:!0});r(e.element,i,e)}function r(e,t,n){e.dispatchEvent(t),n.bindOnce&&ZingTouch.unbind(n.element,n.gesture.getType())}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t,n){var r=o.default.normalizeEvent(t.type),i=[];return e.forEach(function(e){var t=e.gesture[r](n.inputs,n,e.element);t&&!function(){var r=[];n.inputs.forEach(function(e){r.push(e.current)}),i.push({binding:e,data:t,events:r})}()}),i}Object.defineProperty(t,"__esModule",{value:!0});var u=n(5),o=r(u);t.default=i},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){for(var n=0;n<e.length;n++)if(e[n].identifier===t)return e[n];return null}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(4),c=r(s),f=n(10),l=r(f),d=n(12),p=r(d),h=n(13),y=r(h),v=n(14),g=r(v),m=n(15),b=r(m),w=n(16),_=r(w),P=n(17),E=r(P),O=n(18),x=r(O),j=n(5),I=r(j),T=0,k=function(){function e(t){i(this,e),this.regionId=t,this.inputs=[],this.bindings=[],this.numGestures=0,this.registeredGestures={},this.registerGesture(new l.default,"expand"),this.registerGesture(new p.default,"pan"),this.registerGesture(new g.default,"rotate"),this.registerGesture(new y.default,"pinch"),this.registerGesture(new b.default,"swipe"),this.registerGesture(new _.default,"tap")}return a(e,[{key:"addBinding",value:function(e,t,n,r,i){var u=void 0;if(e&&"undefined"==typeof e.tagName)throw new Error("Parameter element is an invalid object.");if("function"!=typeof n)throw new Error("Parameter handler is invalid.");if("string"==typeof t&&Object.keys(this.registeredGestures).indexOf(t)===-1)throw new Error("Parameter "+t+" is not a registered gesture");if("object"===("undefined"==typeof t?"undefined":o(t))&&!(t instanceof c.default))throw new Error("Parameter for the gesture is not of a Gesture type");"string"==typeof t?u=this.registeredGestures[t]:(u=t,""===u.id&&this.assignGestureId(u)),this.bindings.push(new E.default(e,u,n,r,i)),e.addEventListener(u.getId(),n,r)}},{key:"retrieveBindingsByElement",value:function(e){var t=[];return this.bindings.map(function(n){n.element===e&&t.push(n)}),t}},{key:"retrieveBindingsByInitialPos",value:function(){var e=this,t=[];return this.bindings.forEach(function(n){var r=e.inputs.filter(function(e){return I.default.isInside(e.initial.x,e.initial.y,n.element)});r.length>0&&t.push(n)}),t}},{key:"updateInputs",value:function(e,t){function n(e,t,n,r){var i=I.default.normalizeEvent(e.type),o=u(t.inputs,n);return"start"===i&&o?void t.resetInputs():"start"!==i&&o&&!I.default.isInside(o.current.x,o.current.y,r)?void t.resetInputs():"start"===i||o?void("start"===i?t.inputs.push(new x.default(e,n)):o.update(e,n)):void t.resetInputs()}var r=T,i=e.touches?"TouchEvent":e.pointerType?"PointerEvent":"MouseEvent";switch(i){case"TouchEvent":for(var o in e.changedTouches)e.changedTouches.hasOwnProperty(o)&&I.default.isInteger(parseInt(o))&&(r=e.changedTouches[o].identifier,n(e,this,r,t));break;case"PointerEvent":r=e.pointerId,n(e,this,r,t);break;case"MouseEvent":default:n(e,this,T,t)}return!0}},{key:"resetInputs",value:function(){this.inputs=[]}},{key:"numActiveInputs",value:function(){var e=this.inputs.filter(function(e){return"end"!==e.current.type});return e.length}},{key:"registerGesture",value:function(e,t){this.assignGestureId(e),this.registeredGestures[t]=e}},{key:"assignGestureId",value:function(e){e.setId(this.regionId+"-"+this.numGestures++)}}]),e}();t.default=k},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(11),s=r(a),c=function(e){function t(e){i(this,t);var n=u(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.type="expand",n}return o(t,e),t}(s.default);t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(4),c=r(s),f=n(5),l=r(f),d=2,p=1,h=function(e){function t(e){i(this,t);var n=u(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return n.type="distance",n.threshold=e&&e.threshold?e.threshold:p,n}return o(t,e),a(t,[{key:"start",value:function(e,t,n){if(!this.isValid(e,t,n))return null;if(e.length===d){var r=e[0].getGestureProgress(this.type);r.lastEmittedDistance=l.default.distanceBetweenTwoPoints(e[0].current.x,e[1].current.x,e[0].current.y,e[1].current.y)}}},{key:"move",value:function(e,t,n){if(t.numActiveInputs()===d){var r=l.default.distanceBetweenTwoPoints(e[0].current.x,e[1].current.x,e[0].current.y,e[1].current.y),i=l.default.distanceBetweenTwoPoints(e[0].previous.x,e[1].previous.x,e[0].previous.y,e[1].previous.y),u=l.default.getMidpoint(e[0].current.x,e[1].current.x,e[0].current.y,e[1].current.y),o=e[0].getGestureProgress(this.type);if("Expand"===this.constructor.name){if(r<i)o.lastEmittedDistance=r;else if(r-o.lastEmittedDistance>=this.threshold)return o.lastEmittedDistance=r,{distance:r,center:u}}else if(r>i)o.lastEmittedDistance=r;else if(r<i&&o.lastEmittedDistance-r>=this.threshold)return o.lastEmittedDistance=r,{distance:r,center:u};return null}}}]),t}(c.default);t.default=h},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(4),c=r(s),f=n(5),l=r(f),d=1,p=1,h=function(e){function t(e){i(this,t);var n=u(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return n.type="pan",n.numInputs=e&&e.numInputs?e.numInputs:d,n.threshold=e&&e.threshold?e.threshold:p,n}return o(t,e),a(t,[{key:"start",value:function(e){var t=this;e.forEach(function(e){var n=e.getGestureProgress(t.getId());n.active=!0,n.lastEmitted={x:e.current.x,y:e.current.y}})}},{key:"move",value:function(e,t,n){if(this.numInputs===e.length)for(var r={data:[]},i=0;i<e.length;i++){var u=e[i].getGestureProgress(this.getId()),o=!1,a=Math.abs(e[i].current.y-u.lastEmitted.y)>this.threshold,s=Math.abs(e[i].current.x-u.lastEmitted.x)>this.threshold;if(o=a||s,!u.active||!o)return null;r.data[i]={distanceFromOrigin:l.default.distanceBetweenTwoPoints(e[i].initial.x,e[i].current.x,e[i].initial.y,e[i].current.y),directionFromOrigin:l.default.getAngle(e[i].initial.x,e[i].initial.y,e[i].current.x,e[i].current.y),currentDirection:l.default.getAngle(u.lastEmitted.x,u.lastEmitted.y,e[i].current.x,e[i].current.y)},u.lastEmitted.x=e[i].current.x,u.lastEmitted.y=e[i].current.y}return r}},{key:"end",value:function(e){var t=this;return e.forEach(function(e){var n=e.getGestureProgress(t.getId());n.active=!1}),null}}]),t}(c.default);t.default=h},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(11),s=r(a),c=n(5),f=(r(c),function(e){function t(e){i(this,t);var n=u(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.type="pinch",n}return o(t,e),t}(s.default));t.default=f},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(4),c=r(s),f=n(5),l=r(f),d=2,p=function(e){function t(){i(this,t);var e=u(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return e.type="rotate",e}return o(t,e),a(t,[{key:"move",value:function(e,t,n){if(t.numActiveInputs()<=d){var r=void 0,i=void 0,u=void 0,o=void 0;if(1===t.numActiveInputs()){var a=n.getBoundingClientRect();r={x:a.left+a.width/2,y:a.top+a.height/2},o=e[0],i=u=0}else{r=l.default.getMidpoint(e[0].initial.x,e[1].initial.x,e[0].initial.y,e[1].initial.y);var s=l.default.getMidpoint(e[0].current.x,e[1].current.x,e[0].current.y,e[1].current.y);i=r.x-s.x,u=r.y-s.y,o=l.default.getRightMostInput(e)}var c=l.default.getAngle(r.x,r.y,o.current.x+i,o.current.y+u),f=o.getGestureProgress(this.getId());return f.initialAngle?(f.change=l.default.getAngularDistance(f.previousAngle,c),f.distance=f.distance+f.change):(f.initialAngle=f.previousAngle=c,f.distance=f.change=0),f.previousAngle=c,{angle:c,distanceFromOrigin:f.distance,distanceFromLast:f.change}}return null}}]),t}(c.default);t.default=p},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(4),c=r(s),f=n(5),l=r(f),d=1,p=100,h=.2,y=100,v=10,g=function(e){function t(e){i(this,t);var n=u(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return n.type="swipe",n.numInputs=e&&e.numInputs?e.numInputs:d,n.maxRestTime=e&&e.maxRestTime?e.maxRestTime:p,n.escapeVelocity=e&&e.escapeVelocity?e.escapeVelocity:h,n.timeDistortion=e&&e.timeDistortion?e.timeDistortion:y,n.maxProgressStack=e&&e.maxProgressStack?e.maxProgressStack:v,n}return o(t,e),a(t,[{key:"move",value:function(e,t,n){if(this.numInputs===e.length)for(var r=0;r<e.length;r++){var i=e[r].getGestureProgress(this.getId());i.moves||(i.moves=[]),i.moves.push({time:(new Date).getTime(),x:e[r].current.x,y:e[r].current.y}),i.length>this.maxProgressStack&&i.moves.shift()}return null}},{key:"end",value:function(e){if(this.numInputs===e.length){for(var t={data:[]},n=0;n<e.length;n++){if("end"!==e[n].current.type)return;var r=e[n].getGestureProgress(this.getId());if(r.moves&&r.moves.length>2){var i=r.moves.pop();if((new Date).getTime()-i.time>this.maxRestTime)return null;for(var u=void 0,o=r.moves.length-1;o!==-1;){if(r.moves[o].time!==i.time){u=r.moves[o];break}o--}u||(u=r.moves.pop(),u.time+=this.timeDistortion);var a=l.default.getVelocity(u.x,u.y,u.time,i.x,i.y,i.time);t.data[n]={velocity:a,distance:l.default.distanceBetweenTwoPoints(u.x,i.x,u.y,i.y),duration:i.time-u.time,currentDirection:l.default.getAngle(u.x,u.y,i.x,i.y)}}}for(var n=0;n<t.data.length;n++)if(a<this.escapeVelocity)return null;if(t.data.length>0)return t}return null}}]),t}(c.default);t.default=g},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(4),f=r(c),l=n(5),d=r(l),p=0,h=300,y=1,v=10,g=function(e){function t(e){i(this,t);var n=u(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return n.type="tap",n.minDelay=e&&e.minDelay?e.minDelay:p,n.maxDelay=e&&e.maxDelay?e.maxDelay:h,n.numInputs=e&&e.numInputs?e.numInputs:y,n.tolerance=e&&e.tolerance?e.tolerance:v,n}return o(t,e),s(t,[{key:"start",value:function(e){var t=this;return e.length===this.numInputs&&e.forEach(function(e){var n=e.getGestureProgress(t.type);n.start=(new Date).getTime()}),null}},{key:"move",value:function(e,t,n){for(var r=this,i=0;i<e.length;i++)if("move"===e[i].getCurrentEventType()){var u=e[i].current,o=e[i].previous;if(!d.default.isWithin(u.x,u.y,o.x,o.y,this.tolerance)){var s=function(){var t=r.type;return e.forEach(function(e){e.resetProgress(t)}),{v:null}}();if("object"===("undefined"==typeof s?"undefined":a(s)))return s.v}}return null}},{key:"end",value:function(e){var t=this;if(e.length!==this.numInputs)return null;for(var n=Number.MAX_VALUE,r=0;r<e.length;r++){if("end"!==e[r].getCurrentEventType())return null;var i=e[r].getGestureProgress(this.type);if(!i.start)return null;i.start<n&&(n=i.start)}var u=(new Date).getTime()-n;if(this.minDelay<=u&&this.maxDelay>=u)return{interval:u};var o=function(){var n=t.type;return e.forEach(function(e){e.resetProgress(n)}),{v:null}}();return"object"===("undefined"==typeof o?"undefined":a(o))?o.v:void 0}}]),t}(f.default);t.default=g},function(e,t){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var r=function e(t,r,i,u,o){n(this,e),this.element=t,this.gesture=r,this.handler=i,this.capture="undefined"!=typeof u&&u,this.bindOnce="undefined"!=typeof o&&o};t.default=r},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(19),a=r(o),s=function(){function e(t,n){i(this,e);var r=new a.default(t,n);this.initial=r,this.current=r,this.previous=r,this.identifier="undefined"!=typeof n?n:0,this.progress={}}return u(e,[{key:"update",value:function(e,t){this.previous=this.current,this.current=new a.default(e,t)}},{key:"getGestureProgress",value:function(e){return this.progress[e]||(this.progress[e]={}),this.progress[e]}},{key:"getCurrentEventType",value:function(){return this.current.type}},{key:"resetProgress",value:function(e){this.progress[e]={}}}]),e}();t.default=s},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var u=n(5),o=r(u),a=0,s=function e(t,n){i(this,e),this.originalEvent=t,this.type=o.default.normalizeEvent(t.type),this.x=a,this.y=a;var r=void 0;if(t.touches&&t.changedTouches){for(var u=0;u<t.changedTouches.length;u++)if(t.changedTouches[u].identifier===n){r=t.changedTouches[u];break}}else r=t;this.x=this.clientX=r.clientX,this.y=this.clientY=r.clientY,this.pageX=r.pageX,this.pageY=r.pageY,this.screenX=r.screenX,this.screenY=r.screenY};t.default=s}]);

},{}],2:[function(require,module,exports){
require('./dist/zingtouch.min.js');
module.exports = ZingTouch;

},{"./dist/zingtouch.min.js":1}],3:[function(require,module,exports){
"use strict";

var UIService = require('./ui.js');

var AccordionService = {
  mobileIsEnabled: false,
  init: function init() {
    var accordionTrigger = "js-accordion-trigger";
    var accordionOpenClass = "is-open";
    $('.' + accordionTrigger).on('click', function (e) {
      if ($(this).parent().hasClass(accordionOpenClass)) {
        $(this).parent().removeClass(accordionOpenClass);
      } else {
        $('.item').removeClass(accordionOpenClass);
        $(this).parent().addClass(accordionOpenClass);
      }

      e.preventDefault();
    });
    $('.item .corner').on('click', function (e) {
      $(this).parent().removeClass(accordionOpenClass);
    });
    $('#expand-all').on('click', function (e) {
      if ($(this).parent('.accordion').hasClass('all-open')) {
        $(this).parent('.accordion').removeClass('all-open');
        $(this).parent('.accordion').find('.acc-items > .item').removeClass(accordionOpenClass);
      } else {
        $(this).parent('.accordion').find('.acc-items > .item').addClass(accordionOpenClass);
        $(this).parent('.accordion').addClass('all-open');
      }
    }); // KKN-86 : mobile-only accordion of buttons
    // assumption that these will trigger on resize in the UI Service

    $(document).on('sizedToMobile', AccordionService.toggleMobileOnlyAccordion);
    $(document).on('sizedToDesktop', AccordionService.toggleMobileOnlyAccordion);
    this.setupMobileOnlyAccordion();
  },
  setupMobileOnlyAccordion: function setupMobileOnlyAccordion() {
    $('.accordion-mobileonly').on('click', function (e) {
      var accordionOpenClass = "is-open"; // console.log('setupMobileOnlyAccordion : accordion click');

      if ($(this).hasClass(accordionOpenClass)) {
        // how do we decide what's a REAL click on mobile versus a "close this accordion" click
        // assuming that all clicks in an open mobile accordion are "go here now"
        $(this).removeClass(accordionOpenClass);
        $('.stickynav-close').removeClass('visible'); // console.log('setupMobileOnlyAccordion : accordion is open');
      } else {
        // console.log('setupMobileOnlyAccordion : accordion is closed');
        if (UIService.isMobile) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation(); // console.log('setupMobileOnlyAccordion : events stopped');

          $('.stickynav-close').addClass('visible');
        }

        $(this).addClass(accordionOpenClass);
      } // console.log('setupMobileOnlyAccordion : scrolling');

    }); // and the close button
    // TODO: make a little less hardcoded

    $('.stickynav-close').on('click', function (e) {
      $('.accordion-mobileonly').removeClass("is-open");
      $('.stickynav-close').removeClass('visible');
    });
  },
  toggleMobileOnlyAccordion: function toggleMobileOnlyAccordion() {
    AccordionService.mobileIsEnabled = UIService.isMobile;
  }
};
module.exports = AccordionService;

},{"./ui.js":35}],4:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = {
  init: function init() {
    var self = this;
    $('#input_1_12 .gchoice :radio').on('change', function () {
      event.stopPropagation();
      var label = $(this).parent().children('label')[0].innerText;
      self.gtmPush({
        event: 'rtrc.overlayTrayRadioClick',
        radioLabel: "".concat(label)
      });
    });
    $('#input_1_9 .gchoice :checkbox').on('change', function () {
      event.stopPropagation();
      var label = $(this).parent().children('label')[0].innerText;
      self.gtmPush({
        event: 'rtrc.overlayTrayCheckboxClick',
        checkboxLabel: "".concat(label)
      });
    });
  },
  gtmPush: function gtmPush(gtmObj) {
    // console.log(gtmObj);
    if (_typeof(window.dataLayer) == 'object') {
      window.dataLayer.push(gtmObj); // console.log(window.dataLayer)
    }
  }
};

},{}],5:[function(require,module,exports){
"use strict";

module.exports = {
  init: function init() {
    $('.antibody-cell').on('click', function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
      } else {
        $('.antibody-cell').removeClass('active');
        $(this).addClass('active');
      }
    });
  }
};

},{}],6:[function(require,module,exports){
"use strict";

var CustomSelectsService = {
  TOP_LEVEL_SELECTOR: '[data-custom-selects]',
  init: function init() {
    if (typeof $.fn.select2 === 'undefined') {
      return;
    } // console.log('customSelects :: init()');
    // Usage: you need to put the data attribute on a parent element


    $(this.TOP_LEVEL_SELECTOR).find('select').select2({
      width: '100%',
      minimumResultsForSearch: -1
    });
  }
};
module.exports = CustomSelectsService;

},{}],7:[function(require,module,exports){
"use strict";

module.exports = {
  init: function init() {
    var _this = this;

    $(document).on('externalLink', function (event, theExternalLink, modalID, modalContent) {
      _this.handleModal(event, theExternalLink, modalID, modalContent);

      $('body').addClass('exit-modal');
    });
  },
  handleModal: function handleModal(event, theExternalLink, modalID) {
    var modalContent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // get href and target from the anchor tag
    var modalArgs = {
      linkTo: theExternalLink[0].href,
      target: theExternalLink[0].target || '',
      linkElement: theExternalLink[0]
    }; // Check for the exit modal forced newtab flag

    var forcedNewtab = typeof window.wpData !== 'undefined' && typeof window.wpData.exitModalNewtab !== 'undefined' && window.wpData.exitModalNewtab == 1; // Instantiate the modal

    var $modalSelector = $('[data-remodal-id=' + modalID + ']');

    if ($modalSelector.length === 0) {
      return;
    }

    var modal = $modalSelector.remodal(); // Replace the modal copy if set

    if (modalContent) {
      $modalSelector.find('.exitModalContent').html(modalContent);
    } // Removal any existing confirmation triggers...


    $(document).off('confirmation', '[data-remodal-id=' + modalID + ']'); // And add our new trigger, with the information we've provided.

    $(document).on('confirmation', '[data-remodal-id=' + modalID + ']', modalArgs, function (event) {
      if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
          'event': 'rtrc.modalYes',
          'gtm.element': event.data.linkElement
        });
      } // If we're targetting anything


      if (event.data.target !== '') {
        // Use window.open to link with target
        window.open(event.data.linkTo, event.data.target);
      } else {
        // Otherwise, jump to our href
        window.location = event.data.linkTo;
      }
    });
    $(document).on('closing', modal, function () {
      $('body').removeClass('exit-modal');
    }); // Now that we've set things up, open the modal

    modal.open();
  }
};

},{}],8:[function(require,module,exports){
"use strict";

module.exports = {
  init: function init() {
    var sessionStorage = window.sessionStorage;
    var querySting = window.location.search;
    var modalCookie = sessionStorage.getItem("seenCAModal") ? sessionStorage.getItem("seenCAModal") : false;
    var urlParams = new URLSearchParams(querySting);

    if (urlParams.get('ca') == 1 && !modalCookie) {
      var $geoModalElement = $('[data-remodal-id=geomodal]');
      var $geoModal = $geoModalElement.remodal();
      $(document).on('closing', $geoModal, function () {
        sessionStorage.setItem("seenCAModal", true);
      });
      $geoModal.open();
    }
  }
};

},{}],9:[function(require,module,exports){
"use strict";

var _core = require("@popperjs/core");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var Vue = require('vue');

var _ = require('lodash');

module.exports = {
  init: function init() {
    Vue.directive('hover-class', {
      bind: function bind(el, binding, vnode) {
        var _binding$value = binding.value,
            value = _binding$value === void 0 ? "" : _binding$value;

        if (!window.matchMedia('(max-width: 768px)').matches) {
          el.mouseIn = function () {
            el.classList.add(value);
          };

          el.mouseOut = function () {
            el.classList.remove(value);
          };

          el.addEventListener('mouseenter', el.mouseIn);
          el.addEventListener('mouseleave', el.mouseOut);
        }
      },
      unbind: function unbind(el) {
        el.removeEventListener('mouseenter', el.mouseIn);
        el.removeEventListener('mouseleave', el.mouseOut);
      }
    });
    this.LocationModule = new Vue({
      el: '#locationModule',
      data: {
        locations: window.locations,
        headings: window.headings,
        pins: window.pins,
        activeHeading: '',
        headingClicked: false,
        pinClicked: true,
        activePin: '',
        containerHover: false,
        busy: false,
        hasActiveFilter: true,
        activeFilterText: '',
        ui: {
          showHeading: false,
          headingHover: false,
          showPin: false,
          poppers: []
        }
      },
      computed: {
        headingCards: function headingCards() {
          this.filterHeading();
          return this.locations;
        }
      },
      mounted: function mounted() {
        this.resetVueCardData();
        this.$nextTick(function () {
          var _this = this;

          this.$refs['pin'].forEach(function (el) {
            var location = el.dataset.location;
            var pinLocationContainer = _this.$refs[location][0]; // console.log(pinLocationContainer);
            // console.log(el);

            var instance = (0, _core.createPopper)(el, pinLocationContainer, {
              placement: 'right',
              modifiers: [{
                name: 'offset',
                options: {
                  offset: [0, 10]
                }
              }, {
                name: 'preventOverflow',
                options: {
                  boundry: _this.$refs['pin-container'],
                  padding: {
                    top: 60,
                    bottom: 10
                  }
                }
              }, {
                name: 'flip',
                options: {
                  fallbackPlacements: ['left']
                }
              }]
            });
            var popper = {
              'name': location,
              'instance': instance
            };

            _this.ui.poppers.push(popper);
          });
        });
      },
      methods: {
        resetVueCardData: function resetVueCardData() {
          // reset our data with a deep copy of window.cards
          this.locations = JSON.parse(JSON.stringify(window.locations));
        },
        toggleHeading: function toggleHeading(tag) {
          // honestly maybe we should be doing some sort of computed property here that sets is mobile is tablet
          // instead of match media checks in these functions
          if (window.matchMedia('(max-width: 1024px)').matches) {
            if (this.activeHeading == tag) {
              this.activeHeading = '';
              this.headingClicked = false;
            } else {
              if (this.pinClicked) {
                this.activePin = '';
                this.pinClicked = false;
              }

              this.activeHeading = tag;
              this.headingClicked = true;
              this.gtmPush({
                event: 'rtrc.geographicRegionButton',
                heading: "".concat(tag)
              });
            }
          }
        },
        headingLocation: function headingLocation(heading) {
          return this.locations.filter(function (location) {
            return location.heading.indexOf(heading) > -1;
          });
        },
        pinLocation: function pinLocation(heading) {
          return this.locations.filter(function (location) {
            return location.pin.indexOf(heading) > -1;
          });
        },
        togglePin: function togglePin(pin) {
          if (window.matchMedia('(max-width: 1024px)').matches) {
            if (this.activePin == pin) {
              this.activePin = '';
              this.pinClicked = false;
            } else {
              var popper = this.ui.poppers.find(function (pop) {
                return pop.name == pin;
              });

              if (this.headingClicked) {
                this.activeHeading = '';
                this.headingClicked = false;
              }

              this.activePin = pin;
              this.pinClicked = true;
              var pinLocationContainer = this.$refs[pin][0];
              popper.instance.update();
            }
          }
        },
        pinMouseOver: function pinMouseOver(pin) {
          if (!window.matchMedia('(max-width: 1024px)').matches) {
            var popper = this.ui.poppers.find(function (pop) {
              console.log(pop.name);
              console.log(pin);
              return pop.name == pin;
            });

            if (this.headingClicked) {
              this.activeHeading = '';
              this.headingClicked = false;
            }

            console.log(popper);
            this.activePin = pin;
            var pinLocationContainer = this.$refs[pin][0];
            popper.instance.update();
          }
        },
        pinMouseOut: function pinMouseOut(pin) {
          var _this2 = this;

          if (!window.matchMedia('(max-width: 1024px)').matches) {
            var pinLocationContainer = this.$refs[pin][0];
            setTimeout(function () {
              if (!_this2.containerHover) {
                _this2.activePin = '';
              }
            }, 200);
          }
        },
        pinContainerMouseOver: function pinContainerMouseOver() {
          this.pinContainerHover = true;
        },
        pinContainerMouseOut: function pinContainerMouseOut() {
          this.pinContainerHover = false;
        },
        headingMouseOver: function headingMouseOver(heading) {
          if (!window.matchMedia('(max-width: 1024px)').matches) {
            if (this.activeHeading != heading) {
              this.activeHeading = heading;
              this.gtmPush({
                event: 'rtrc.geographicRegionButton',
                heading: "".concat(heading)
              });
            }
          }
        },
        headingContainerMouseOver: function headingContainerMouseOver() {
          this.pinContainerHover = true;
        },
        headingContainerMouseOut: function headingContainerMouseOut() {
          this.pinContainerHover = false;
        },
        headingMouseOut: function headingMouseOut(heading) {
          var _this3 = this;

          if (this.ui.headingHover) {
            return;
          }

          if (!window.matchMedia('(max-width: 1024px)').matches) {
            setTimeout(function () {
              if (!_this3.containerHover && _this3.activeHeading == heading) {
                _this3.activeHeading = '';
              }
            }, 200);
          }
        },
        clickCard: function clickCard(id) {
          $('#location-full-' + id).addClass('active');
          $('#locationModule').addClass('full-expanded');
          this.gtmPush({
            event: 'rtrc.locationCardClick',
            location: "".concat(id)
          });
        },
        gtmPush: function gtmPush(gtmObj) {
          console.log(gtmObj);

          if (_typeof(window.dataLayer) == 'object') {
            window.dataLayer.push(gtmObj);
            console.log(window.dataLayer);
          }
        }
      }
    });
    $('.location-full-box .corner').on('click', function () {
      var locationExpandedID = $(this).closest('.location-full').attr('id');
      $('#' + locationExpandedID).removeClass('active');
      $('#locationModule').removeClass('full-expanded');
    });
  }
};

},{"@popperjs/core":"@popperjs/core","lodash":"lodash","vue":"vue"}],10:[function(require,module,exports){
"use strict";

var slick = require('slick-carousel');

module.exports = {
  init: function init() {
    if ($('.home-hero .hero-slides').length) {
      $(".home-hero .hero-slides").slick({
        infinite: false,
        dots: true,
        arrows: false,
        fade: true,
        speed: 1000
      });
    }

    if ($('.auto-rotate .hero-slides').length) {
      $(".auto-rotate .hero-slides").slick({
        infinite: false,
        dots: false,
        arrows: false,
        fade: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 8000
      });
    }
  }
};

},{"slick-carousel":"slick-carousel"}],11:[function(require,module,exports){
"use strict";

var hoverIntent = require('jquery-hoverintent');

var ui = require('./ui.js');

module.exports = {
  init: function init() {
    // at a glance box rollovers
    $(".component-at-a-glance .box").hoverIntent(function () {
      if (ui.isMobile == false && ui.isTablet == false) {
        $(this).addClass('active');
      }
    }, function () {
      if (ui.isMobile == false && ui.isTablet == false) {
        $(this).removeClass('active');
      }
    });
    $("#join-kyowa-kirin .component-large-image-with-organic-ctas .shape").hoverIntent(function () {
      if (ui.isMobile == false && ui.isTablet == false) {
        $(this).addClass('active');
      }
    }, function () {
      if (ui.isMobile == false && ui.isTablet == false) {
        $(this).removeClass('active');
      }
    });
  }
};

},{"./ui.js":35,"jquery-hoverintent":"jquery-hoverintent"}],12:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _emblaCarousel = _interopRequireWildcard(require("embla-carousel"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

module.exports = {
  init: function init() {
    var wrap = document.querySelector(".embla");
    var viewPort = wrap.querySelector(".embla__viewport");
    var prevBtn = wrap.querySelector(".embla__button--prev");
    var nextBtn = wrap.querySelector(".embla__button--next");
    var dots = document.querySelector(".embla__dots");
    var embla = (0, _emblaCarousel["default"])(viewPort, {
      loop: false,
      skipSnaps: false
    });
    var dotsArray = this.generateDotBtns(dots, embla);
    var setSelectedDotBtn = this.selectDotBtn(dotsArray, embla);
    var disablePrevAndNextBtns = this.disablePrevNextBtns(prevBtn, nextBtn, embla);
    this.setupPrevNextBtns(prevBtn, nextBtn, embla);
    this.setupDotBtns(dotsArray, embla);
    embla.on("select", setSelectedDotBtn);
    embla.on("select", disablePrevAndNextBtns);
    embla.on("init", setSelectedDotBtn);
    embla.on("init", disablePrevAndNextBtns);
  },
  setupPrevNextBtns: function setupPrevNextBtns(prevBtn, nextBtn, embla) {
    prevBtn.addEventListener('click', embla.scrollPrev, false);
    nextBtn.addEventListener('click', embla.scrollNext, false);
  },
  disablePrevNextBtns: function disablePrevNextBtns(prevBtn, nextBtn, embla) {
    return function () {
      if (embla.canScrollPrev()) prevBtn.removeAttribute('disabled');else prevBtn.setAttribute('disabled', 'disabled');
      if (embla.canScrollNext()) nextBtn.removeAttribute('disabled');else nextBtn.setAttribute('disabled', 'disabled');
    };
  },
  setupDotBtns: function setupDotBtns(dotsArray, embla) {
    dotsArray.forEach(function (dotNode, i) {
      dotNode.addEventListener("click", function () {
        return embla.scrollTo(i);
      }, false);
      dotNode.ariaLabel = "Scroll To Slide ".concat(i + 1);
    });
  },
  generateDotBtns: function generateDotBtns(dots, embla) {
    var template = document.getElementById("embla-dot-template").innerHTML;
    dots.innerHTML = embla.scrollSnapList().reduce(function (acc) {
      return acc + template;
    }, "");
    return [].slice.call(dots.querySelectorAll(".embla__dot"));
  },
  selectDotBtn: function selectDotBtn(dotsArray, embla) {
    return function () {
      var previous = embla.previousScrollSnap();
      var selected = embla.selectedScrollSnap();
      dotsArray[previous].classList.remove("is-selected");
      dotsArray[selected].classList.add("is-selected");
    };
  }
};

},{"embla-carousel":"embla-carousel"}],13:[function(require,module,exports){
"use strict";

var ui = require("./ui");

module.exports = {
  originalPlayer: undefined,
  init: function init() {
    this.bindLeadershipHandler();
  },
  bindLeadershipHandler: function bindLeadershipHandler() {
    var self = this;
    $(".collapsed-employee[data-remodal-target]").on('click', function () {
      ui.freezeScroll();
      var $modal = $('.expanded-employee.remodal').remodal();
      $(document).off('opening', '.expanded-employee.remodal');
      $(document).on('opening', '.expanded-employee.remodal', function () {});
      $(document).off('closing', '.expanded-employee.remodal');
      $(document).on('closing', '.expanded-employee.remodal', function () {
        ui.unFreezeScroll();
      });
      $modal.open();
    });
  }
};

},{"./ui":35}],14:[function(require,module,exports){
"use strict";

var Scrollbar = require('smooth-scrollbar');

var ui = require('./ui.js');

module.exports = {
  init: function init() {
    Scrollbar.initAll({
      alwaysShowTracks: false
    });
  }
};

},{"./ui.js":35,"smooth-scrollbar":"smooth-scrollbar"}],15:[function(require,module,exports){
"use strict";

var _screenshot = require("./screenshot.js");

var remodal = require('remodal');

var ui = require('./ui.js');

var navigation = require('./navigation.js');

var hero = require('./hero.js');

var quotes = require('./quotes.js');

var tabbedComponent = require('./tabbed-component.js');

var scrollTo = require('./scrollTo.js');

var mediaCards = require('./mediaCards.js');

var home = require('./home.js');

var leadership = require('./leadership.js');

var antibodies = require('./antibodies.js');

var whoWeAre = require('./who-we-are.js');

var globalNetwork = require('./global-network.js');

var accordions = require('./accordion.js');

var exitModal = require('./exitModal.js');

var overlayTray = require('./overlayTray.js');

var searchForm = require('./search-form');

var showmore = require('./showmore');

var videoModal = require('./video-modal.js');

var leadershipModal = require('./leadership-modal.js');

var storiesApp = require('./storiesApp.js');

var customSelects = require('./customSelects.js');

var analytics = require('./analytics.js');

var textClamp = require('./text-clamp.js');

var socialShare = require('./socialShare.js');

var meetTheMembers = require('./meet-the-members');

var pipeline = require('./pipeline');

var scrollSpy = require('./scrollSpy.js');

var internalCarousel = require('./internal-carousel.js');

var textWitbBoxesOnSide = require('./text-with-boxes-on-side.js');

var geoTargeting = require('./geo-targeting.js');

var shareArticle = require('./share-article.js');

require('./vendor/twitterFetcher.min.js'); // require('./vendor/intersection-observer.js');


var twitterConfig = require('./twitter-config.js');

var stickyAnchorNav = require('./stickyAnchorNav.js');

$(document).ready(function () {
  ui.init();
  navigation.init();
  hero.init();
  quotes.init();
  tabbedComponent.init();
  scrollTo.init();
  home.init();
  leadership.init();
  antibodies.init();
  whoWeAre.init();
  geoTargeting.init();
  accordions.init();
  exitModal.init();
  searchForm.init();
  showmore.init();
  overlayTray.init();
  textWitbBoxesOnSide.init();
  leadershipModal.init();
  customSelects.init();
  meetTheMembers.init();
  scrollSpy.init();

  if ($(".component-internal-carousel").length > 0) {
    internalCarousel.init();
  }

  if ($(".component-media-center-sticky-anchor-nav").length > 0) {
    // console.log('mc sticky nav found in main.js');
    stickyAnchorNav.init();
  }

  if ($('.newsVue').length > 0) {
    //console.log('init newsVue');
    mediaCards.init();
  }

  if ($('.mediaApp').length > 0) {
    storiesApp.init();
  }

  if ($('[data-custom-selects]').length > 0) {
    customSelects.init();
  }

  if ($('#locationModule').length > 0) {
    globalNetwork.init();
  }

  videoModal.init();
  analytics.init();

  if ($('.twitter').length > 0) {
    twitterConfig.init();
  }

  if ($('.js-clampWrap').length > 0) {
    textClamp.init();
  }

  if ($('.js-socialShare').length > 0) {
    socialShare.init();
  }

  if ($('.js-pipeline').length > 0) {
    pipeline.init();
  }

  if ($('.single-newsfeed_post').length) {
    shareArticle.init();
  }
});
$(window).scroll(function () {
  scrollSpy.activeSection();
});

},{"./accordion.js":3,"./analytics.js":4,"./antibodies.js":5,"./customSelects.js":6,"./exitModal.js":7,"./geo-targeting.js":8,"./global-network.js":9,"./hero.js":10,"./home.js":11,"./internal-carousel.js":12,"./leadership-modal.js":13,"./leadership.js":14,"./mediaCards.js":16,"./meet-the-members":17,"./navigation.js":18,"./overlayTray.js":19,"./pipeline":20,"./quotes.js":21,"./screenshot.js":22,"./scrollSpy.js":23,"./scrollTo.js":24,"./search-form":25,"./share-article.js":26,"./showmore":27,"./socialShare.js":28,"./stickyAnchorNav.js":29,"./storiesApp.js":30,"./tabbed-component.js":31,"./text-clamp.js":32,"./text-with-boxes-on-side.js":33,"./twitter-config.js":34,"./ui.js":35,"./vendor/twitterFetcher.min.js":37,"./video-modal.js":38,"./who-we-are.js":39,"remodal":"remodal"}],16:[function(require,module,exports){
"use strict";

var _emblaCarousel = _interopRequireWildcard(require("embla-carousel"));

var _lodash = require("lodash");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var Vue = require('vue');

var infiniteScroll = require('vue-infinite-scroll');

var _ = require('lodash');

var hoverIntent = require('jquery-hoverintent');

var lineClamp = require('line-clamp');

module.exports = {
  init: function init() {
    var _this = this;

    // a shameful global
    var firstpass = true;

    var cardMouseOver = function cardMouseOver() {
      _this.classList.add(value);
    };

    var cardMouseOut = function cardMouseOut() {
      _this.classList.remove(value);
    }; // Directive for outside click


    Vue.directive('click-outside', {
      bind: function bind(el, binding, vnode) {
        el.event = function (event) {
          // here I check that click was outside the el and its children
          if (!(el == event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };

        document.body.addEventListener('click', el.event); //console.log(el);
      },
      unbind: function unbind(el) {
        document.body.removeEventListener('click', el.event);
        el.removeEventListener('mouseenter');
        el.removeEventListener('mouseleave');
      }
    });
    Vue.directive('hover-class', {
      bind: function bind(el, binding, vnode) {
        var _binding$value = binding.value,
            value = _binding$value === void 0 ? "" : _binding$value;

        el.mouseIn = function () {
          el.classList.add(value);
        };

        el.mouseOut = function () {
          el.classList.remove(value);
        };

        el.addEventListener('mouseenter', el.mouseIn);
        el.addEventListener('mouseleave', el.mouseOut);
      },
      unbind: function unbind(el) {
        el.removeEventListener('mouseenter', el.mouseIn);
        el.removeEventListener('mouseleave', el.mouseOut);
      }
    }); // TODO: tinker for 1 hour trying to separate Filter and Pagination into their own Vue() objects
    // why? to make these things more readable, less mammoth-sized, more single-responsibility
    // if this looks like it's a huge ordeal, just abandon ship and flag to team
    // this.filterControl = new Vue({ ... });
    // this.paginationControl = new Vue({ ... });
    // Init the app

    this.app = new Vue({
      el: '.newsVue',
      components: {},
      data: {
        cards: JSON.parse(JSON.stringify(window.cards)),
        // we sort and filter on THIS set of cards, here being assigned via deep-copy
        tags: window.tags || [],
        activeFilter: window.tags[0].tagname || 'north_america',
        activeFilterText: window.tags[0].id || 'north_america',
        // new begin
        //dropdowntags: window.dropdown,
        //activeDropdownCategory: window.dropdown[0].name || '',
        //activeDropdownCategorySlug: window.dropdown[0].slug || '',
        // new end
        infScrollBusy: true,
        infScrollAfterEnterCount: 0,
        forceGridViewMobile: true,
        busy: false,
        isHovering: false,
        ui: {
          isGrid: true,
          filterOpen: false,
          dropdownFilterOpen: false,
          sortOrderAsc: false,
          sortBy: 'date',
          // ['dateRaw', 'title'], contains actual state of user's sort selection
          sortByDate: false,
          // Vue.js control boolean
          sortByTitle: false,
          // Vue.js control bool
          pageSize: window.pageSize,
          // Default page size is 8
          mobilePageSize: window.mobilePageSize,
          // Default mobile page size is 2
          tabletPageSize: window.tabletPageSize,
          // Default tablet page size is 4
          currentPageSize: window.pageSize,
          // at any time, represents active page size. changes with screen width 
          cardCount: cards.length,
          forcedGrid: false,
          // if we did force someone's browser to go into grid layout mode
          isMobile: false,
          isTablet: false
        },
        embla: null,
        emblaReInitFlag: false,
        scrollSnaps: [],
        selectedScrollSnap: null,
        lastScrollSnap: null,
        prevBtnEnabled: false,
        nextBtnEnabled: true,
        slides: [],
        numberOfSlides: 1
      },
      computed: {
        newsCards: function newsCards() {
          this.sortCards(); // Add a the current number of cards to the visible cards

          return this.cards.slice(0, this.ui.cardCount);
        },
        newsSlides: function newsSlides() {
          this.sortCards();
          this.cardCount = this.cards.length; // console.log('Cards' + this.cards);

          var visibleCards = this.cards.slice(0, this.ui.cardCount); // console.log('Visible Cards' + visibleCards.length);
          // console.log(this.ui.cardCount);
          // Calculate the number of slides if there is one extra since we are taking up the space of two cards 

          var visibleCardCount = visibleCards.length;

          if (this.activeFilterText == 'north_america') {
            visibleCardCount = visibleCards.length + 1;
          }

          var numSlides = Math.ceil(visibleCardCount / this.ui.currentPageSize); // KKN-86 : only for the first page of filtered cards, the first card is larger and the count is reduced by 1
          // if( JSON.stringify(visibleCards[0]) == JSON.stringify(this.cards[0]) ) {
          // console.log('newsSlides : they are the same!');
          // numSlides = Math.ceil(visibleCards.length/this.ui.currentPageSize) - 1;
          // }
          // console.log('Ui CardCount' + this.ui.cardCount);
          // console.log(this.ui.currentPageSize);
          // console.log('NumSlides' + numSlides);

          var tempSlides = [];

          for (var x = 0; x < numSlides; x++) {
            var pageSize = this.ui.currentPageSize;

            if (!this.ui.isMobile && x == 0 && this.activeFilterText == 'north_america') {
              pageSize = this.ui.currentPageSize - 1;
            }

            var start = x * pageSize;
            var end = pageSize * (x + 1);
            tempSlides.push(visibleCards.slice(start, end)); // console.log(x);
          } // Add a the current number of cards to the visible cards


          this.slides = tempSlides;

          if (this.embla) {
            this.updateEmblaPagination();
          }

          return this.slides;
        },
        hrefTarget: function hrefTarget() {
          return this.activeFilterText == "north_america" ? "_self" : "_blank";
        }
      },
      mounted: function mounted() {
        // run this code one time, regardless of current setting
        this.updatePageSize(); // run a sort on the initial pageload

        this.sortCards(); // Add a page of cards to the view

        this.addPageOfCards(); // Filter the cards

        this.filterAllCards(); // remove the SEO-based  Static PHP/HTML
        // $( '.articleCardsHtml' ).remove();
        // Add a resize listener for the filter

        $(window).on('resize', _.throttle(this.resizeListener, 60)); // resolving a strange page-load issue on mobile

        this.infScrollBusy = false; // check if there is a filter present in the URL query string

        var urlFilter = this.getURLFilter();

        if (urlFilter) {
          this.filter(urlFilter);
        } // These are all the options for the embla carousel


        this.emblaOptions = {
          loop: false,
          align: 'start',
          containScroll: 'trimSnaps',
          inViewThreshold: 1,
          slidesToScroll: 1
        }; // Grab the embla node

        this.emblaNode = document.getElementById("embla"); // console.log(this.emblaNode);
        // Instantiate the carousel

        this.embla = (0, _emblaCarousel["default"])(this.emblaNode, this.emblaOptions);
        this.embla.on("select", this.onSelect);
      },
      updated: function updated() {
        this.$nextTick(function () {
          // console.log('updated : $nextTick');
          // if we know we need to reInit embla, do it ONE TIME
          // this prevent an infinite loop that crashes the browser
          if (this.emblaReInitFlag == true) {
            // console.log('updated : $nextTick : embla.reInit');
            this.embla.reInit();
            this.updateEmblaPagination(); // update the flag to signal that we've re-initialized 1 time

            this.emblaReInitFlag = false;
          } // This returns all the slide nodes so 


          var slideNumber = this.embla.slideNodes(); // console.log(slideNumber.length);
          // if(slideNumber.length > 1) {
          //     this.scrollSnaps = this.embla.scrollSnapList();
          //     console.log(this.scrollSnaps);
          // }

          this.calcEllipsis();
        }); // If there are no scroll snaps it returns an array with 1 element NaN
        // let scrollSnaps = this.embla.scrollSnapList();
        // if(isNaN(scrollSnaps[0])) {
        //     this.scrollSnaps = [-0]
        //     console.log('nan')
        // } else {
        //     this.scrollSnaps = this.embla.scrollSnapList()
        // }
        // console.log(this.embla.scrollSnapList()) 
      },
      methods: {
        // Embla on select of the Filter tab
        onSelect: function onSelect() {
          this.selectedScrollSnap = this.embla.selectedScrollSnap();
          this.prevBtnEnabled = this.embla.canScrollPrev();
          this.nextBtnEnabled = this.embla.canScrollNext();
        },
        resetScrollSnap: function resetScrollSnap() {
          // scroll back to the beginning, for ex. when the user changes the filter
          this.selectedScrollSnap = this.embla.selectedScrollSnap();
          this.embla.scrollTo(0);
        },
        // Embla updating of the pagination links
        updateEmblaPagination: function updateEmblaPagination() {
          // we need to do a few things save it to a variable
          var snapList = this.embla.scrollSnapList(); // Get the list of scrollsnaps and set the data object to scroll snaps

          this.scrollSnaps = snapList;

          if (isNaN(snapList[snapList.length - 1])) {
            this.lastScrollSnap = 0;
          } else {
            this.lastScrollSnap = snapList.length - 1;
          } // fire this function to refresh pagination "snaps"


          this.onSelect();
        },
        resetVueCardData: function resetVueCardData() {
          // reset our data with a deep copy of window.cards
          this.cards = JSON.parse(JSON.stringify(window.cards));
        },
        applyActiveSettings: function applyActiveSettings(n) {
          // Think of this as a main() or a digest cycle triggered when users want to sort or filter
          // Settings changes are triggered when those controls update
          // This function fires the actual sorting and filtering processes
          // reset the card data to start
          this.resetVueCardData();
          this.updatePageSize();
          this.filterAllCards();
          this.sortCards();
          this.updateEmblaPagination(); // this.calcEllipsis();
        },
        filterAllCards: function filterAllCards() {
          var _this2 = this;

          var filteredCards = this.cards; // for category filtering

          var hasActiveFilter = this.activeFilterText !== "all";
          this.emblaReInitFlag = true;
          filteredCards = this.cards.filter(function (card) {
            // let in all cards by default
            var filterCondition = true;
            var origin = card.feedOrigin.toLowerCase();
            origin = origin.replace(' ', '_');
            var pillarFilter = origin == _this2.activeFilterText; // card.feedOrigin.indexOf( this.activeFilterText ) > -1;

            if (hasActiveFilter) {
              filterCondition = pillarFilter;
            }

            return filterCondition;
          });
          this.cards = filteredCards;
        },
        getNextPageSize: function getNextPageSize() {
          // returns up to 1 more page of any filtered remaining cards
          var remainingCardCount = this.cards.length - this.newsCards.length;
          var rv = Math.min(this.ui.currentPageSize, remainingCardCount);
          return rv;
        },
        addPageOfCards: function addPageOfCards() {
          //console.log("blog landing Vue :: addPageOfCards");
          var nextPageSize = this.getNextPageSize(); // update our Vue property

          this.ui.cardCount = this.newsCards.length + nextPageSize; //console.log(this.ui.cardCount);

          this.gtmPush({
            event: 'rtrc.infiniteScrollLoad',
            cardsLoaded: "".concat(this.ui.cardCount),
            totalCards: "".concat(this.cards.length)
          });
        },
        addPageOfCards_infScroll: function addPageOfCards_infScroll() {
          // console.log("blog landing Vue :: addPageOfCards_infScroll");
          // Purpose: This function exists to help debounce the loading of card pages when infinite scrolling is enabled.
          // We're using the vue-infinite-scroll hooks @ https://github.com/ElemeFE/vue-infinite-scroll
          // we need to get at the Vue instance "this" inside a timeout anon function
          var me = this;

          if (cards.length == this.ui.cardCount) {
            me.infScrollBusy = true; // disable the INF_SCROLLING

            return false;
          }

          me.infScrollBusy = true;
          setTimeout(function () {
            // add a page of card padding to the whole container BEFORE we load in new cards
            // me.infScrollPaddingOn();
            // IIFE to keep this synchronous
            (function (obj) {
              obj.addPageOfCards();
            })(me); // me.infScrollPaddingOff();


            me.infScrollBusy = false;
          }, 90);
        },
        afterEnter: function afterEnter() {
          // Purpose: Count how many Cards are added when new pages are loaded with Infinite Scrolling, and then do something after a page is done
          // console.log("blog landing Vue :: afterEnter");
          this.infScrollAfterEnterCount++; // hotfix for a min-height style workaround. this was inherited from CELG
          // this.infScrollPaddingOff();
          // have we loaded a full page of cards, or did we load all the cards?

          if (this.infScrollAfterEnterCount % this.ui.currentPageSize == 0 || this.cards.length == this.infScrollAfterEnterCount) {
            this.infScrollPaddingOff();
          }
        },
        infScrollPaddingOn: function infScrollPaddingOn() {
          // To prevent a Chrome recurring mishap from consistently happening, we add a blank page of cards worth of padding
          var cardsPerRow = 3;
          var cardHeight = $(".articleCard:first").height();
          var nextPageSize = this.getNextPageSize();

          if (nextPageSize > 0) {
            $(".wrap-cards").css("paddingBottom", cardHeight * Math.ceil(nextPageSize / cardsPerRow));
          }
        },
        infScrollPaddingOff: function infScrollPaddingOff() {
          $(".wrap-cards").css("paddingBottom", 0);
        },
        filter: function filter(tag, clickedIndex) {
          //console.log("filter :: filtering on tag: " + tag);
          $('.tagFilter').removeClass('active');
          $('.filter_' + tag).addClass('active'); // hide all videos

          this.hideVideos(); // Unset the active tag

          var activeTagIndex = _.findIndex(this.tags, function (tag) {
            return tag.isActive;
          });

          this.tags[activeTagIndex].isActive = false; // Set our new active tag to the clicked tag

          this.tags[activeTagIndex].isActive = true;
          this.activeFilter = $('.filter_' + tag).text();
          this.activeFilterText = tag; // run the sort and filters

          this.applyActiveSettings(); // scroll back to the beginning, for ex. when the user changes the filter

          this.resetScrollSnap();
          this.gtmPush({
            event: 'rtrc.filterCards',
            blogFilter: "".concat(this.activeFilterText)
          });
        },
        filterDropdown: function filterDropdown(tag, clickedIndex) {
          // hide all videos
          this.hideVideos(); // Unset the active tag

          var activeTagIndex = _.findIndex(this.dropdowntags, function (tag) {
            return tag.isActive;
          });

          this.dropdowntags[activeTagIndex].isActive = false; // Set our new active tag to the clicked tag

          this.dropdowntags[clickedIndex].isActive = true;
          this.activeDropdownCategory = this.dropdowntags[clickedIndex].tagname;
          this.activeDropdownCategorySlug = tag; // run the sort and filters

          this.applyActiveSettings();
        },
        sortCards: function sortCards() {
          //console.log('hello');
          // sorts based on whatever sort criteria is active in this.ui.sortBy, using whichever direction is set
          var sortOrder = this.ui.sortOrderAsc ? 'asc' : 'desc';

          var sortedArray = _.orderBy(this.cards, [this.ui.sortBy], [sortOrder]);

          this.cards = sortedArray; // overwrite the original object with the sorted array. If we screw it up, we can use this.resetVueCardData()
        },
        toggleGrid: function toggleGrid(showGrid) {
          this.ui.isGrid = showGrid;
        },
        toggleDropdownFilterOpen: function toggleDropdownFilterOpen() {
          this.ui.dropdownFilterOpen = !this.ui.dropdownFilterOpen;
        },
        closeDropdownFilter: function closeDropdownFilter() {
          if (this.ui.dropdownFilterOpen) {
            this.ui.dropdownFilterOpen = false;
          }
        },
        toggleFilterOpen: function toggleFilterOpen() {
          this.ui.filterOpen = !this.ui.filterOpen;
        },
        closeOpenFilter: function closeOpenFilter() {
          if (this.ui.filterOpen) {
            this.ui.filterOpen = false;
          }
        },
        showVideo: function showVideo(event, index) {
          event.preventDefault();
          event.stopPropagation();
          this.newsCards[index].show_video = true;
        },
        hideVideos: function hideVideos() {
          this.newsCards.forEach(function (card) {
            card.show_video = false;
          });
        },
        // switches between mobile and desktop page sizes
        updatePageSize: function updatePageSize() {
          if (window.matchMedia("(max-width:767px)").matches) {
            this.ui.isMobile = true;
            this.ui.isTablet = false;
            this.ui.currentPageSize = this.ui.mobilePageSize;
          } else if (window.matchMedia("(max-width:1024px)").matches) {
            this.ui.isMobile = false;
            this.ui.isTablet = true;
            this.ui.currentPageSize = this.ui.tabletPageSize;
          } else {
            this.ui.isMobile = false;
            this.ui.isTablet = false;
            this.ui.currentPageSize = this.ui.pageSize;
          } // do not call applyActiveSettings in here or you'll infinite loop

        },
        // abstracted the throttled resize-listener into this specific function, opening it up to do more
        // Jeremy M, 28 Jan 2019
        resizeListener: function resizeListener() {
          if (window.matchMedia("(max-width:767px)").matches) {
            if (this.forceGridViewMobile && this.ui.isGrid == false) {
              this.ui.forcedGrid = true;
              this.ui.isGrid = true;
            }

            this.shutFilterDropdown();
          } else {
            // if we forced them, turn it off
            if (this.ui.forcedGrid == true) {
              this.ui.isGrid = false;
              this.ui.forcedGrid = false;
            }
          } // run the sort and filters


          this.applyActiveSettings();
        },

        /**
         * The faux-dropdown filter gets stuck open when transitioning to mobile. If we're on mobile, close it up.
         * @author Rob Szpila <robert@arteric.com>
         */
        shutFilterDropdown: function shutFilterDropdown() {
          this.ui.filterOpen = false;
        },
        getTarget: function getTarget(newTab) {
          var targetString = "_self";

          if (newTab) {
            targetString = "_blank";
          }

          return targetString;
        },
        getOpener: function getOpener(newTab) {
          var targetString = "";

          if (newTab) {
            targetString = "noopener";
          }

          return targetString;
        },
        getLink: function getLink(link) {
          if (link === '') {
            return false;
          } else {
            return link;
          }
        },
        // For Newsroom Sort Ordering
        setOrderAsc: function setOrderAsc(bool) {
          var val = !!bool;

          if (val != this.ui.sortOrderAsc) {
            this.ui.sortOrderAsc = !!bool; // we escape whatever value is provided into Boolean form
          }

          var sortOrder = this.ui.sortOrderAsc ? 'Ascending' : 'Descending';
          this.gtmPush({
            event: 'rtrc.sortOrder',
            sortOrder: "".concat(sortOrder)
          });
          this.applyActiveSettings();
        },
        // For Newsroom Sorting
        setSortType: function setSortType(sorttype) {
          var typeList = ['dateRaw', 'title'];

          if (sorttype != this.ui.sortBy && typeList.indexOf(sorttype) != -1) {
            this.ui.sortBy = sorttype; // given functional sort type is allowed, update it

            this.gtmPush({
              event: 'rtrc.blogSortBy',
              blogSortBy: "".concat(this.ui.sortBy)
            });
          } else {
            return; // user clicked the same sort type again, or it's a disallowed sort type
          } // update the visual booleans, which are not the functional key


          switch (sorttype) {
            case 'dateRaw':
              this.ui.sortByDate = true;
              this.ui.sortByTitle = false;
              break;

            case 'title':
              this.ui.sortByDate = false;
              this.ui.sortByTitle = true;
              break;
          }

          this.applyActiveSettings();
        },
        tagExistsInList: function tagExistsInList(tag) {
          var name = _.filter(this.tags, function (o) {
            return o.id == tag;
          });

          return name.length > 0;
        },
        getTag: function getTag(tag) {
          var name = _.filter(this.tags, function (o) {
            return o.id == tag;
          });

          if (name.length > 0) {
            return '#' + name[0].tagname;
          }

          return '';
        },
        getURLFilter: function getURLFilter() {
          var href = window.location.href;
          var rv = null;

          if (href.indexOf("filter=") >= 0) {
            var filterText = href.split('filter=')[1]; // remove any other query string params that may exist after the data

            filterText = filterText.split('/')[0]; // console.log("getURLFilter :: string after / : " + filterText);

            filterText = filterText.split('&')[0]; // console.log("getURLFilter :: string after & : " + filterText);

            filterText = filterText.split('#')[0]; // console.log("getURLFilter :: string after # : " + filterText);

            rv = filterText;
          }

          return rv;
        },
        gtmPush: function gtmPush(gtmObj) {
          if (_typeof(window.dataLayer) == 'object') {
            window.dataLayer.push(gtmObj);
          }
        },
        isFirstSlide: function isFirstSlide(slideObj, compareToObj) {
          var rv = false;

          if (_typeof(slideObj) !== 'object') {
            console.warn('mediaCards :: isFirstSlide : argument not an object!');
            return false;
          }

          if (_typeof(compareToObj) !== 'object') {
            console.warn('mediaCards :: isFirstSlide : comparison argument not an object!');
            return false;
          }

          if (JSON.stringify(slideObj) == JSON.stringify(compareToObj)) {
            rv = true;
          }

          return rv;
        },
        calcEllipsis: function calcEllipsis() {
          var cards = document.querySelectorAll('.newsApp .cardSlide.is-selected .mediaCard'); // console.log('New Function Call');
          // were only going to se these on the first card to try and save some time

          var bodyHeight = 0;
          var titleLineHeight = 0;
          var titleLines = 0;
          cards.forEach(function (el, i) {
            // console.log(el);
            var cardBody = el.querySelector('.cardBody');

            if (_typeof(cardBody)) {
              var cardTitle = el.querySelector('.cardTitle');
              var cardContent = el.querySelector('.cardContent');
              var contentLineHeight = parseFloat(window.getComputedStyle(cardContent).getPropertyValue("line-height"));

              if (i == 0) {
                bodyHeight = cardBody.offsetHeight;
                titleLineHeight = parseFloat(window.getComputedStyle(cardTitle).getPropertyValue("line-height"));
                titleLines = Math.floor(bodyHeight / titleLineHeight);
              } // console.log(titleLines);


              var titleClamp = lineClamp(cardTitle, titleLines);

              if (!titleClamp) {
                var titleHeight = cardTitle.offsetHeight;
                var contentLines = Math.floor((bodyHeight - titleHeight) / contentLineHeight);
                lineClamp(cardContent, contentLines);
              } else {
                cardContent.classList.add('hide');
              }
            } // console.log('title: ' + titleLines);
            // console.log('content: ' + contentLines);

          });
        }
      },
      // end methods section
      directives: {
        infiniteScroll: infiniteScroll
      }
    });
  }
};

},{"embla-carousel":"embla-carousel","jquery-hoverintent":"jquery-hoverintent","line-clamp":"line-clamp","lodash":"lodash","vue":"vue","vue-infinite-scroll":"vue-infinite-scroll"}],17:[function(require,module,exports){
"use strict";

var ui = require('./ui.js');

module.exports = {
  init: function init() {
    $('.member').on('click', function () {
      $(this).toggleClass('active');
    });
  }
};

},{"./ui.js":35}],18:[function(require,module,exports){
"use strict";

var hoverIntent = require('jquery-hoverintent');

var ui = require('./ui.js');

module.exports = {
  init: function init() {
    var self = this; // navigation dropdowns

    $("header nav > ul > li").hoverIntent({
      over: function over() {
        if (ui.isMobile == false && ui.isTablet == false) {
          $(this).addClass('active');
        }
      },
      out: function out() {
        if (ui.isMobile == false && ui.isTablet == false) {
          $(this).removeClass('active');
          $(this).find('.sub-menu-wrap').removeClass('overflow');
        }
      },
      timeout: 250
    }); // subnavigation dropdowns

    $("ul.sub-menu > li.menu-item-has-children").hoverIntent({
      over: function over() {
        if (ui.isMobile == false && ui.isTablet == false) {
          $('ul.sub-menu li.menu-item-has-children').removeClass('active');

          if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).closest('.sub-menu-wrap').removeClass('overflow');
          } else {
            $(this).addClass('active');
            $(this).closest('.sub-menu-wrap').addClass('overflow');
          }
        }
      },
      out: function out() {
        if (ui.isMobile == false && ui.isTablet == false) {
          $(this).removeClass('active'); //$(this).closest('.sub-menu-wrap').removeClass('overflow');
        }
      },
      timeout: 250
    });
    $('header nav > ul > li.menu-item-has-children > .arrow').on('click', function (event) {
      if (ui.isMobile == true || ui.isTablet == true) {
        if ($(this).parent().hasClass('active')) {
          $('header nav > ul > li').removeClass('not-active active');
        } else {
          $('header nav > ul > li').addClass('not-active');
          $(this).parent().removeClass('not-active').addClass('active');
        }
      }
    });
    $('ul.sub-menu li.menu-item-has-children > .arrow').on('click', function (event) {
      if (ui.isMobile == true || ui.isTablet == true) {
        if ($(this).parent().hasClass('active')) {
          $(this).parent().removeClass('active');
        } else {
          $('ul.sub-menu li.menu-item-has-children').removeClass('active');
          $(this).parent().addClass('active');
        }

        event.preventDefault();
      }
    }); // mobile nav functionality

    $('.icon.burger').on('click', function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('.nav-wrapper').removeClass('active');
        ui.unFreezeScroll();
      } else {
        $(this).addClass('active');
        $('.nav-wrapper').addClass('active');
        ui.freezeScroll();
      }
    });
    $(document).on('gform_confirmation_loaded', function () {
      $('.the-form').addClass('confirmation');
      $('.the-form').addClass('confirmation');
    });
    /* Accessiblity Additions */

    $('a').on('focus', function (e) {
      if ($(this).parents('.form-holder:not(.active)').length == 1) {
        $('.js-trayToggle').trigger('click');
      } else if ($('.form-holder').hasClass('active') && $(this).parents('.form-holder').length == 0) {
        $('.js-trayClose').trigger('click');
      }

      if ($(this).parent('.menu-item-has-children:not(".active")').length == 1) {
        $(this).parent('.menu-item-has-children, .menu-item').siblings().removeClass('active');
        $(this).parent('.menu-item-has-children, .menu-item').siblings().find('.sub-menu-wrap').removeClass('overflow');
        $(this).parent('.menu-item-has-children').addClass('active');
        $(this).parent('.menu-item-has-children').find('.sub-menu-wrap').addClass('overflow');
      }

      if ($(this).parents('#menu-header-menu').length != 1) {
        $('.menu-item-has-children').removeClass('active');
        $('.menu-item-has-children').find('.sub-menu-wrap').removeClass('overflow');
      }
    });
  }
};

},{"./ui.js":35,"jquery-hoverintent":"jquery-hoverintent"}],19:[function(require,module,exports){
"use strict";

var ui = require("./ui");

var overlayTray = {
  init: function init() {
    var $trayToggle = $('.js-trayToggle');
    var $trayClose = $('.js-trayClose');
    $trayToggle.on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var trayID = $(this).data("tray");
      overlayTray.trayOpen($(this).data("tray"));
    });
    $trayClose.on("click", function (e) {
      e.preventDefault();
      var $tray = $(this).parents().find("div[data-trayID]");
      overlayTray.trayClose($tray);
      var gwrf_1 = window.gwrf_1;
      var gwrf_2 = window.gwrf_2;

      if (typeof gwrf != 'undefined') {
        setTimeout(function () {
          if ($('#gf_1').length) {
            gwrf_1.reloadForm();
          }

          if ($('#gf_2').length) {
            gwrf_2.reloadForm();
          }

          $('.the-form').removeClass('confirmation');
        }, 500);
      }
    });
  },
  trayOpen: function trayOpen(trayID) {
    var $tray = $("div[data-trayID=".concat(trayID, "]"));
    var $trayToggle = $(".js-trayToggle[data-tray=".concat(trayID, "]"));

    if ($tray.length > 0) {
      $('.remodal-overlay').css("display", "block");
      $("div[data-trayID=".concat(trayID, "]")).addClass('active');
      ui.freezeScroll();
      $('.js-trayClose').on('click', function (e) {
        //console.log($trayToggle.has(e.target).length)
        if ($tray.has(e.target).length === 0 && $trayToggle.has(e.target).length === 0) {
          //console.log('close');
          overlayTray.trayClose($tray);
        }
      });
    }
  },
  trayClose: function trayClose($tray) {
    if ($tray.hasClass("active")) {
      $('.remodal-overlay').css("display", "none");
      $tray.removeClass("active");
      ui.unFreezeScroll();
    }
  }
};
module.exports = overlayTray;

},{"./ui":35}],20:[function(require,module,exports){
"use strict";

var UIService = require('./ui.js');

var ZingTouch = require('zingtouch');

var PipelineSvc = {
  items: window.kkn_pipeline_items,
  areas: window.kkn_pipeline_area,
  phases: window.kkn_pipeline_phases,
  mobileActiveColumn: null,
  init: function init() {
    // set up column listeners for sorting
    this.columnListeners(); // set up accordion listeners

    this.accordionListeners();
    this.mobileDropdownListeners();
  },
  accordionListeners: function accordionListeners() {
    // toggle the accordion expansion
    $('.component-pipeline').find('.wrap-columns').on('click', function () {
      $(this).parents('.row:not(.headings)').toggleClass('expanded');
    });
  },
  mobileDropdownListeners: function mobileDropdownListeners() {
    $('.sorting-selected').on('click', function () {
      $('.sorting-dropdown').addClass('active');
    });
  },
  sortHandler: function sortHandler(evt) {
    // console.log('PipelineSvc : sortHandler');
    var outershell = $('.component-pipeline').find('.pipeline'); // get the sort parameter & sort order (asc / desc)

    var sortParam = $(evt.currentTarget).data('sortby');
    var sortOrder = outershell.attr('data-sort-order');

    if (typeof sortOrder == 'undefined') {
      sortOrder = 'asc';
    } else {
      // toggle between asc / desc
      sortOrder = sortOrder == 'asc' ? 'desc' : 'asc';
    }

    var currentSortParam = window.PipelineSvc.getSortParam(); // if this is a NEW sorting column being clicked on, use 'asc' sort order

    if (sortParam != currentSortParam) {
      sortOrder = 'asc';
    } // update the chosen sort in the mobile dropdown


    var selectedOption = $('.sorting-dropdown-option').html();
    $('.sorting-dropdown').removeClass('active');
    $('.sorting-selected').html(sortParam); // put sort param & order on the pipeline as a global to reference

    window.PipelineSvc.setSortParam(sortParam);
    window.PipelineSvc.setSortOrder(sortOrder); // apply the sort functionality

    window.PipelineSvc.sortColumn(sortParam);
  },
  columnListeners: function columnListeners() {
    // sort parameters on row headings
    $('[data-sortby]').on('click', window.PipelineSvc.sortHandler); // remove the above handler ONLY IF we're on a touch-enabled device
    // why? to disable the sort from firing twice (and appearing broken)

    $(document).on('sizedToMobile', function () {
      $('[data-sortby]').off('click');
    });
    $(document).on('sizedToDesktop', function () {
      $('[data-sortby]').on('click', window.PipelineSvc.sortHandler);
    }); // do the same as the above but with a tap gesture

    var containerElement = $('.sorting-options').get(0);
    var activeRegion = ZingTouch.Region(containerElement);
    $('.sorting-dropdown-option').each(function () {
      // bind each of the dropdown options to the sort handler
      activeRegion.bind(this, 'tap', window.PipelineSvc.sortHandler);
      var selectedOption = $('.sorting-dropdown-option').html();
      $('.sorting-dropdown').removeClass('active');
      $('.sorting-selected').html(selectedOption);
    }); // mobile row width spacing

    $('.component-pipeline').find('.column').on('click', function (e) {
      // if(window.UIService.isMobile == false) { return false; }
      // console.log('you clicked a column in mobile');
      var mobileIsExpanded = $(this).parents('.pipeline').hasClass('mobileExpanded'); // only let taps on the + columns open

      if ($(this).hasClass('candidate')) {
        if (mobileIsExpanded) {
          e.preventDefault();
        } else {
          $(this).parents('.pipeline').toggleClass('mobileExpanded');
        }
      } else {
        if ($(this).hasClass('indication')) {
          if (mobileIsExpanded) {
            $(this).parents('.pipeline').toggleClass('mobileExpanded');
          } else {
            e.preventDefault();
          }
        }
      }
    });
  },
  getSortOrder: function getSortOrder() {
    return $('.component-pipeline').find('.pipeline').attr('data-sort-order');
  },
  setSortOrder: function setSortOrder(val) {
    $('.component-pipeline').find('.pipeline').attr('data-sort-order', val);
  },
  getSortParam: function getSortParam() {
    return $('.component-pipeline').find('.pipeline').attr('data-sort');
  },
  setSortParam: function setSortParam(val) {
    $('.component-pipeline').find('.pipeline').attr('data-sort', val);
  },
  sortColumn: function sortColumn(colName) {
    var sortOrder = window.PipelineSvc.getSortOrder(); // console.log(`PipelineSvc :: sortColumn : sorting ${sortOrder} on ${colName}`);
    // execute the sort

    var $sorted = $('.pipeline .row:not(.headings)').sort(function (a, b) {
      var one = $(a).find('[data-' + colName + ']').data(colName);
      var two = $(b).find('[data-' + colName + ']').data(colName); // swap the comparison if the sort direction is asc vs desc

      if (sortOrder == 'asc') {
        var tmp = one;
        one = two;
        two = tmp;
      } // console.log('pipeline :: sort between (' + one + ', ' + two + ')');


      return one < two ? 1 : -1;
    });
    $sorted.appendTo('.pipeline');
  },
  isMobile: function isMobile() {
    var rv = window.UIService.isMobile;
    return rv;
  }
};
var svc = PipelineSvc;
window.PipelineSvc = PipelineSvc;
module.exports = PipelineSvc;

},{"./ui.js":35,"zingtouch":2}],21:[function(require,module,exports){
"use strict";

var slick = require('slick-carousel');

module.exports = {
  init: function init() {
    if ($('.quotes').length && $('.quote').length > 1) {
      $(".quotes").slick({
        infinite: true,
        dots: false,
        arrows: false,
        fade: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 30000,
        pauseOnHover: false
      });
    }
  }
};

},{"slick-carousel":"slick-carousel"}],22:[function(require,module,exports){
"use strict";

// Purpose: to list any/all functions to reveal any hidden content for screenshots
var svcObject = {
  init: function init(page) {
    $('body').addClass('screenshot');
    this.cookieNotice();
  },
  cookieNotice: function cookieNotice() {
    $('#cookie-notice').css('position', 'relative');
  }
}; // create window.arteric namespace, if needed

if (!window.arteric) {
  window.arteric = {};
} // expose the service to the window.arteric namespace


window.arteric['screenshot'] = svcObject; // export the service to the any module requiring it

module.exports = svcObject;

},{}],23:[function(require,module,exports){
"use strict";

var ui = require('./ui.js');

var spyService = {
  scrollURLtoSpy: null,
  viewportHeight: $(window).height(),
  headerHeight: $('header').outerHeight(),
  obserserverHeight: null,
  init: function init() {
    spyService.activeSection();
  },
  activeSection: function activeSection() {
    spyService.viewportHeight = $(window).height();
    spyService.headerHeight = $('header').outerHeight();
    spyService.obserserverHeight = spyService.viewportHeight - spyService.headerHeight - 50;

    if (!!window.IntersectionObserver) {
      // most things
      var observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            spyService.scrollURLtoSpy = window.location.pathname + '#' + entry.target.id;
            $('ul.sub-menu li ul.sub-menu li').removeClass('active');
            $('ul.sub-menu li ul.sub-menu li a[href*="' + spyService.scrollURLtoSpy + '"]').parent().addClass('active');
          }
        });
      }, {
        rootMargin: "0px 0px -" + spyService.obserserverHeight + "px 0px"
      });
      document.querySelectorAll('main section').forEach(function (img) {
        observer.observe(img);
      });
    }
  }
};
module.exports = spyService;
window.spyService = spyService;

},{"./ui.js":35}],24:[function(require,module,exports){
"use strict";

var easings = require('./vendor/jqueryEasings.js');

var ui = require('./ui.js');

var overlayTray = require('./overlayTray.js');

module.exports = {
  /**
   * Setup a listener for a hashchange and also see if there was a hash defined on pageload
   * @author Rob Szpila <robert@arteric.com>
   */
  init: function init() {
    // Excerpt from jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
    // jQuery.easing['swing'] = jQuery.easing['swing'];
    jQuery.extend(jQuery.easing, {
      easeInOutCubic: function easeInOutCubic(x, t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t + 2) + b;
      }
    });
    var self = this;
    var url = location.href;
    var hash = location.hash;
    var hashOBJ = hash;
    var ieOffsetDone = false;
    var headerHeight = $('header').outerHeight();
    var sectionScrollOffset; // any links with hashes, scroll to hash

    $('body').on('click', 'a[href*="#"]', function (e) {
      var $this = $(this);
      var href = $this.attr('href');
      var hash = href.substring(href.indexOf('#'), href.length);

      if ($('.icon.burger').hasClass('active')) {
        $('.icon.burger').removeClass('active');
        $('.nav-wrapper').removeClass('active');
        ui.unFreezeScroll();
      }

      if ($('body').attr('data-page') == 'our-medicines' && hash == '#medical-information-request-tray') {
        self.openMedicalInformationTray();
        $('.tray-holder[data-trayid="medical-information-request"]').addClass('active');
      } else {
        if (self.hashInDOM(hash)) {
          e.preventDefault();
          self.scrollToHashHelper(hash);
        }
      }
    });

    if (hash.length) {
      setTimeout(function () {
        $('html,body').scrollTop(0);

        if ($('body').attr('data-page') == 'our-medicines' && hash == '#medical-information-request-tray') {
          self.openMedicalInformationTray();
        } else if ($('body').attr('data-page') == 'partnerships' && hash == '#transforming') {
          self.openTransformingTray(); //$('.tray-holder[data-trayid="transforming"]').addClass('active');
        } else if (url.includes('?gh_jid=') == true) {
          self.jumpToSection('#career-opportunities');
        } else {
          self.scrollTo(hash, false);
        }
      }, 100); //console.log('scrollto inside hash');
    } else if (url.includes('?gh_jid=') == true) {
      self.jumpToSection('#career-opportunities');
    }
  },
  openMedicalInformationTray: function openMedicalInformationTray() {
    overlayTray.trayOpen('medical-information-request');
  },
  openTransformingTray: function openTransformingTray() {
    overlayTray.trayOpen('transforming');
  },

  /**
   * A wrapper function that first checks for a modal, then calls scrollToHash
   * just an attempt to keep things a bit more DRY
   * @param  {jQuery} $hashElement the DOM element to jump to
   * @author Rob Szpila <robert@arteric.com>
   */
  scrollToHashHelper: function scrollToHashHelper(hash) {
    //console.log('scrollToHashHelper = '+hash);
    var self = this;
    self.scrollToHash(hash);
  },

  /**
   * Given an element (in this case a jumplink target) scroll to it and dont ask any qestions
   * @param  {jQuery} $hashElement the DOM element to jump to
   * @author Rob Szpila <robert@arteric.com>
   */
  scrollToHash: function scrollToHash(hash) {
    //console.log('scrollToHash');
    // if ie11, force 1px movement to fix scrolling bug
    //IE11 detection
    var ua = window.navigator.userAgent;
    var trident = ua.indexOf('Trident/');
    var ieOffset = 0;
    var scroll = $(window).scrollTop();
    this.moveToSection(hash);
  },
  // a generic version of Rob's scroll mechanism where we can scroll to anything passed in, with an exposed callback
  scrollTo: function scrollTo(selector, callback) {
    //console.log('scrollTo '+selector);
    var $dest = selector instanceof jQuery ? selector : $(selector);

    if ($dest.length == 0) {
      return false;
    }

    this.moveToSection(selector);
  },
  moveToSection: function moveToSection(selector) {
    this.headerHeight = $('header').outerHeight();
    this.sectionScrollOffset = this.headerHeight + 20;

    if ($('body').hasClass('isTablet') || $('body').hasClass('isMobile')) {
      var offset = $(selector).offset().top - this.sectionScrollOffset;
    } else {
      var offset = $(selector).offset().top - this.sectionScrollOffset;
    } // sticky nav offset


    var mc_stickynav = $(".component-media-center-sticky-anchor-nav");
    var extraOffset = mc_stickynav.length > 0 ? mc_stickynav.outerHeight() : 0;
    offset -= extraOffset;
    var distance = Math.abs(offset - $(window).scrollTop());
    var speed = 700;
    $('html, body').animate({
      'scrollTop': offset
    }, {
      'duration': speed
    });
  },
  jumpToSection: function jumpToSection(selector) {
    console.log('jumpToSection');
    this.headerHeight = $('header').outerHeight();
    this.sectionScrollOffset = this.headerHeight + 50;
    var offset = parseInt($(selector).offset().top - this.sectionScrollOffset);
    window.scrollTo(0, offset);
  },

  /**
   * Check the DOM for a hash, if there isnt one, it's probably a modal or something
   * @param  {string}		hash the hash from the URL
   * @return {bool}		if there hash exists in the DOM or not
   */
  hashInDOM: function hashInDOM(hash) {
    var haveHash = false;
    this.$hashElement = $(hash);

    if (this.$hashElement.length > 0) {
      haveHash = true;
    }

    return haveHash;
  }
};

},{"./overlayTray.js":19,"./ui.js":35,"./vendor/jqueryEasings.js":36}],25:[function(require,module,exports){
"use strict";

var ui = require('./ui.js');

var SearchFormService = {
  init: function init() {
    this.$searchIcon = $(".icon.search");
    this.$searchClose = $(".search-bar-icon.close");
    this.setupHandlers();
  },
  setupHandlers: function setupHandlers() {
    this.$searchIcon.on('click', SearchFormService.openSearchBar);
    this.$searchClose.on('click', SearchFormService.closeSearchBar);
  },
  openSearchBar: function openSearchBar() {
    $('.search-bar').addClass('active');
  },
  closeSearchBar: function closeSearchBar() {
    $('.search-bar').removeClass('active');
    $('input#search').val('');
  }
};
module.exports = SearchFormService;

},{"./ui.js":35}],26:[function(require,module,exports){
"use strict";

module.exports = {
  init: function init() {
    $('.share-button-action').on('click', function () {
      $(this).next().fadeIn();
      $(this).next().addClass('modal-open');
    });
    $('.close-share').on('click', function () {
      $(this).parent().parent().fadeOut();
      $(this).parent().parent().removeClass('modal-open');
    });
    /* $(document).on('click', function(e) {
        if($('.share-modal').hasClass('modal-open') && e.target != '')
        console.log(e)
    }) */

    $(document).on('keydown', function (e) {
      if ((e.keyCode == 27 || e.key == "Escape") && $('.share-modal').hasClass('modal-open')) {
        $('.share-modal').fadeOut();
        $('.share-modal').removeClass('modal-open');
      }
    });
    $('#copy-link').on('click', function (e) {
      var element = document.querySelector('.share-footer input');
      var val = element.value;
      element.select();
      element.setSelectionRange(0, 99999);
      document.execCommand('copy');
      element.value = 'Link Copied';
      setTimeout(function () {
        element.value = val;
      }, 600);
    });
  }
};

},{}],27:[function(require,module,exports){
"use strict";

module.exports = {
  init: function init() {
    /*
          $(".button.show-more").each(function() {
    	var this = $(this);
    	var $content = this.parent().prev(".paginated-item");
    		var visibleHeight = $content[0].clientHeight;
    	var actualHide = $content[0].scrollHeight - 1;
    		console.log(actualHide);
    	console.log(visibleHeight);
    		if (actualHide > visibleHeight) {
    		this.show();
    	} else {
    		this.hide();
    	}
    });
    	$(".button.show-more").on("click", function() {
    	var this = $(this);
    	var $content = this.parent().prev(".paginated-item");
    	var linkText = this.text();
    		$content.toggleClass("short-text, full-text");
    		return false;
    });
    */
  }
};

},{}],28:[function(require,module,exports){
"use strict";

module.exports = {
  init: function init() {
    this.initNormalShare();
  },
  initNormalShare: function initNormalShare() {
    /** HEADER ICONS */
    $('.js-share-facebook').on('click', function (event) {
      event.preventDefault(); // ASSUMED suggested dimensions: 520x350

      window.open('https://www.facebook.com/sharer/sharer.php?u=' + window.location.href, '_blank', 'width=520,height=350');
    });
    $('.js-share-twitter').on('click', function (event) {
      event.preventDefault(); // Official suggested dimensions: 550x420

      var twitterUrl = 'https://twitter.com/intent/tweet?url=' + window.location.href; // Replace into the message

      window.open(twitterUrl, '_blank', 'width=550,height=420');
    });
    $('.js-share-linkedin').on('click', function (event) {
      event.preventDefault(); // Official Suggested dimensions: 520x570

      window.open('https://www.linkedin.com/shareArticle?url=' + window.location.href, '_blank', 'width=520,height=570');
    });
    $('.js-share-googleplus').on('click', function (event) {
      event.preventDefault(); // Official Suggested dimensions: 600x600. Parameters taken straight from G+ dev site

      window.open('https://plus.google.com/share?url=' + window.location.href, '_blank', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
    });
  }
};

},{}],29:[function(require,module,exports){
"use strict";

var _ = require('lodash');

var StickyAnchorNavService = {
  navSelector: '.component-media-center-sticky-anchor-nav',
  nav: null,
  activeTarget: "",
  init: function init() {
    this.$window = $(window);
    var self = this; // console.log('StickyAnchorNav :: init');
    // do we have a sticky nav on this page?

    StickyAnchorNavService.nav = $(StickyAnchorNavService.navSelector);

    if (StickyAnchorNavService.nav.length > 0) {
      // console.log('StickyAnchorNav :: found one!');
      // this.setupScrollListener();
      this.setupIO(); // resize things
      // this.setupResizeListener();
      // run the resize overflow-checker one time at pageload
      // this.detectOverflow();
    }
  },
  toggleHeight: function toggleHeight() {
    StickyAnchorNavService.nav.toggleClass('open-height');
  },
  detectOverflow: function detectOverflow() {
    // stickynav-link
    var innerSubNavHeight = $('.stickynav-link').get(0).scrollHeight;
    var subNavMarginBottom = parseInt(StickyAnchorNavService.nav.css('margin-bottom'));
    var outerSubNavHeight = StickyAnchorNavService.nav.innerHeight() + subNavMarginBottom; // console.log(innerSubNavHeight + " > " + outerSubNavHeight + " => " + (innerSubNavHeight > outerSubNavHeight));

    if (innerSubNavHeight > outerSubNavHeight) {
      StickyAnchorNavService.nav.addClass('overflowing');
    } else {
      StickyAnchorNavService.nav.removeClass('overflowing');
    }
  },
  setupResizeListener: function setupResizeListener() {
    var _this = this;

    /** A debounced resize function */
    var debouncedResize = _.throttle(function () {
      _this.resize();
    }, 50); // call the debounced function on resize


    this.$window.resize(function () {
      debouncedResize();
    });
  },
  resize: function resize() {
    this.detectOverflow();
  },
  setupScrollListener: function setupScrollListener() {
    var _this2 = this;

    // console.log('StickyAnchorNav :: setupScrollListener');
    var nav = StickyAnchorNavService.nav;
    var nav_height = nav.outerHeight();
    var subnav_array = [];

    var debouncedScroll = _.throttle(function () {
      _this2.scrollHandler();
    }, 50); // name this scroll event "mcstickynav"


    $(window).on('scroll.mcstickynav', function () {
      // console.log('scroll.mcstickynav');
      debouncedScroll();
    });
  },
  setupIO: function setupIO() {
    var nav = StickyAnchorNavService.nav; // var nav_height = nav.outerHeight();

    var nav_height = $('header').outerHeight();
    var header = document.querySelector('.component-media-center-sticky-anchor-nav');
    var top_nav = document.querySelector('.navbar-top');
    var sections = document.querySelectorAll('section');
    var docHeight = window.innerHeight;
    var rootMarginBottom = docHeight - (nav_height + 10); //OBSERVE HEADER POSITION - determine if header is sticky or not and add a class

    var observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        var targetInfo = entry.boundingClientRect;
        var stickyTarget = entry.target.parentElement.querySelector('.container');
        var rootBoundsInfo = entry.rootBounds;
        var target = entry.target;

        if (targetInfo.top <= rootBoundsInfo.bottom) {
          if (!target.classList.contains('sticky')) {
            target.classList.add('sticky');
          }
        }

        if (targetInfo.top > rootBoundsInfo.bottom) {
          if (target.classList.contains('sticky')) {
            target.classList.remove('sticky');
          }
        }
      });
    }, {
      root: null,
      rootMargin: "0px 0px -".concat(rootMarginBottom, "px 0px"),
      threshold: 0
    });
    observer.observe(header); //OBSERVE SECTION POSITION

    var intersectionObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.target.id != StickyAnchorNavService.activeTarget) {
          // this.pickSubnavSection(entry.target.id);
          // console.log('entering section => ' + entry.target.id);
          $('.stickynav-link[data-target="#' + entry.target.id + '"]').addClass('active');
          $('.stickynav-link[data-target="#' + StickyAnchorNavService.activeTarget + '"]').removeClass('active');
          $('ul.sub-menu li').removeClass('active');
          $('ul.sub-menu li a[href*="' + entry.target.id + '"]').parent().addClass('active');
          StickyAnchorNavService.activeTarget = entry.target.id;
        } else {// $('.stickynav-link[data-target="#'+ entry.target.id +'"]').removeClass('active');
        }
      }); // }, {rootMargin: '0px 0px -100%', threshold: 0});
    }, {
      rootMargin: "-50% 0px"
    });
    sections.forEach(function (section) {
      return intersectionObserver.observe(section);
    });
    /**
     * Dispatches the `sticky-event` custom event on the target element.
     * @param {boolean} stuck True if `target` is sticky.
     * @param {!Element} target Element to fire the event on.
     */

    function fireEvent(stuck, target) {
      var e = new CustomEvent('sticky-change', {
        detail: {
          stuck: stuck,
          target: target
        }
      });
      document.dispatchEvent(e);
    }
  },
  scrollHandler: function scrollHandler() {
    var $subnav = StickyAnchorNavService.nav;
    var navHeight = $subnav.outerHeight();
    var content_offset = $(window).scrollTop() + 1; // var content_offset = $(window).scrollTop() + navHeight + 1;
    // console.log("content_offset = " + content_offset);

    var $buttons = $(".stickynav-link");
    $buttons.each(function (index) {
      var me = $(this); // var myID = me.attr('id').replace('subnav-', '');
      // expected data format: '#sectionname'

      var myID = me.data('target');
      var $section = $(myID); // Requires jquery.inview

      if ($section.length > 0) {
        $section.on('inview', function (evt, isInView) {
          me.toggleClass('active', isInView);
        });
      }
    });
  }
};
module.exports = StickyAnchorNavService;

},{"lodash":"lodash"}],30:[function(require,module,exports){
"use strict";

var _emblaCarousel = _interopRequireWildcard(require("embla-carousel"));

var _lodash = require("lodash");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var Vue = require('vue');

var _ = require('lodash');

var hoverIntent = require('jquery-hoverintent');

module.exports = {
  init: function init() {
    // a shameful global
    var firstpass = true;
    var self = this;
    var $components = $('.mediaVue');

    if ($components.length > 0) {
      $components.each(function (index) {
        var id = $(this).attr('id');
        self.createVue(id);
      });
    }
  },
  createVue: function createVue(id) {
    var _this = this;

    var element = "#".concat(id);

    var cardMouseOver = function cardMouseOver() {
      _this.classList.add(value);
    };

    var cardMouseOut = function cardMouseOut() {
      _this.classList.remove(value);
    }; // Directive for outside click


    Vue.directive('click-outside', {
      bind: function bind(el, binding, vnode) {
        el.event = function (event) {
          // here I check that click was outside the el and its children
          if (!(el == event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };

        document.body.addEventListener('click', el.event); //console.log(el);
      },
      unbind: function unbind(el) {
        document.body.removeEventListener('click', el.event);
        el.removeEventListener('mouseenter');
        el.removeEventListener('mouseleave');
      }
    });
    Vue.directive('hover-class', {
      bind: function bind(el, binding, vnode) {
        var _binding$value = binding.value,
            value = _binding$value === void 0 ? "" : _binding$value;

        el.mouseIn = function () {
          el.classList.add(value);
        };

        el.mouseOut = function () {
          el.classList.remove(value);
        };

        el.addEventListener('mouseenter', el.mouseIn);
        el.addEventListener('mouseleave', el.mouseOut);
      },
      unbind: function unbind(el) {
        el.removeEventListener('mouseenter', el.mouseIn);
        el.removeEventListener('mouseleave', el.mouseOut);
      }
    });
    this.app = new Vue({
      el: ".mediaVue".concat(element),
      data: {
        cards: JSON.parse(JSON.stringify(window["".concat(id)].cards)),
        forceGridViewMobile: true,
        busy: false,
        isHovering: false,
        ui: {
          isGrid: true,
          sortOrderAsc: false,
          sortBy: 'date',
          // ['dateRaw', 'title'], contains actual state of user's sort selection
          sortByDate: false,
          // Vue.js control boolean
          sortByTitle: false,
          // Vue.js control bool
          pageSize: window["".concat(id)].pageSize,
          // Default page size is 8
          mobilePageSize: window["".concat(id)].mobilePageSize,
          // Default mobile page size is 2
          tabletPageSize: window["".concat(id)].tabletPageSize,
          currentPageSize: window["".concat(id)].pageSize,
          // at any time, represents active page size. changes with screen width 
          cardCount: cards.length,
          forcedGrid: false // if we did force someone's browser to go into grid layout mode
          // usingMobilePageSize: false // we have run the code that listens for changes from mobile to desktop

        },
        embla: null,
        emblaReInitFlag: false,
        scrollSnaps: [],
        selectedScrollSnap: null,
        lastScrollSnap: null,
        prevBtnEnabled: false,
        nextBtnEnabled: true,
        slides: [],
        numberOfSlides: 1
      },
      computed: {
        storiesCards: function storiesCards() {
          this.sortCards(); // Add a the current number of cards to the visible cards

          return this.cards.slice(0, this.ui.cardCount);
        },
        storiesSlides: function storiesSlides() {
          this.sortCards();
          this.cardCount = this.cards.length; // console.log('Cards' + this.cards);

          var visibleCards = this.cards.slice(0, this.ui.cardCount); // console.log('Visible Cards' + visibleCards.length);

          var numSlides = Math.ceil(visibleCards.length / this.ui.currentPageSize); // console.log('Ui CardCount' + this.ui.cardCount);
          // console.log(this.ui.currentPageSize);
          // console.log('NumSlides' + numSlides);

          var tempSlides = [];

          for (var x = 0; x < numSlides; x++) {
            var start = x * this.ui.currentPageSize;
            var end = this.ui.currentPageSize * (x + 1);
            tempSlides.push(visibleCards.slice(start, end)); // console.log(x);
          } // Add a the current number of cards to the visible cards


          this.slides = tempSlides;

          if (this.embla) {
            this.updateEmblaPagination();
          }

          return this.slides;
        }
      },
      mounted: function mounted() {
        // console.log('mounted');
        // run this code one time, regardless of current setting
        this.updatePageSize(); // run a sort on the initial pageload

        this.sortCards(); // Add a page of cards to the view

        this.addPageOfCards(); // remove the SEO-based  Static PHP/HTML
        // $( '.articleCardsHtml' ).remove();
        // Add a resize listener for the filter

        $(window).on('resize', _.throttle(this.resizeListener, 60)); // resolving a strange page-load issue on mobile

        this.infScrollBusy = false; // check if there is a filter present in the URL query string

        var urlFilter = this.getURLFilter();

        if (urlFilter) {
          this.filter(urlFilter);
        } // These are all the options for the embla carousel


        this.emblaOptions = {
          loop: false,
          align: 'start',
          containScroll: 'trimSnaps',
          inViewThreshold: 1,
          slidesToScroll: 1
        }; // Grab the embla node

        this.emblaNode = document.getElementById("embla-".concat(id)); // console.log(this.emblaNode);
        // KKN-86 : if it's for the Media Center Resources section, it should be centered
        // get type??

        if (id == 'resources') {
          this.emblaOptions['align'] = 'center';
        } // Instantiate the carousel


        this.embla = (0, _emblaCarousel["default"])(this.emblaNode, this.emblaOptions);
        this.embla.on("select", this.onSelect);
      },
      updated: function updated() {
        this.$nextTick(function () {
          // console.log('updated : $nextTick');
          // if we know we need to reInit embla, do it ONE TIME
          // this prevent an infinite loop that crashes the browser
          if (this.emblaReInitFlag == true) {
            // console.log('updated : $nextTick : embla.reInit');
            this.embla.reInit();
            this.updateEmblaPagination(); // update the flag to signal that we've re-initialized 1 time

            this.emblaReInitFlag = false;
          } // This returns all the slide nodes so 


          var slideNumber = this.embla.slideNodes(); // console.log(slideNumber.length);
        });
      },
      methods: {
        // Embla on select of the Filter tab
        onSelect: function onSelect() {
          this.selectedScrollSnap = this.embla.selectedScrollSnap();
          this.prevBtnEnabled = this.embla.canScrollPrev();
          this.nextBtnEnabled = this.embla.canScrollNext();
          this.emblaReInitFlag = true;
        },
        // Embla updating of the pagination links
        updateEmblaPagination: function updateEmblaPagination() {
          // we need to do a few things save it to a variable
          var snapList = this.embla.scrollSnapList(); // Get the list of scrollsnaps and set the data object to scroll snaps

          this.scrollSnaps = snapList;

          if (isNaN(snapList[snapList.length - 1])) {
            this.lastScrollSnap = 0;
          } else {
            this.lastScrollSnap = snapList.length - 1;
          } // fire this function to refresh pagination "snaps"


          this.onSelect();
        },
        resetVueCardData: function resetVueCardData() {
          // reset our data with a deep copy of window.cards
          this.cards = JSON.parse(JSON.stringify(window["".concat(id)].cards));
        },
        applyActiveSettings: function applyActiveSettings(n) {
          // Think of this as a main() or a digest cycle triggered when users want to sort or filter
          // Settings changes are triggered when those controls update
          // This function fires the actual sorting and filtering processes
          // reset the card data to start
          this.resetVueCardData();
          this.updatePageSize(); // this.filterAllCards();

          this.sortCards();
          this.updateEmblaPagination();
        },
        getNextPageSize: function getNextPageSize() {
          // returns up to 1 more page of any filtered remaining cards
          var remainingCardCount = this.cards.length - this.storiesCards.length;
          return Math.min(this.ui.currentPageSize, remainingCardCount);
        },
        addPageOfCards: function addPageOfCards() {
          //console.log("blog landing Vue :: addPageOfCards");
          var nextPageSize = this.getNextPageSize(); // update our Vue property

          this.ui.cardCount = this.storiesCards.length + nextPageSize; //console.log(this.ui.cardCount);

          this.gtmPush({
            event: 'rtrc.infiniteScrollLoad',
            cardsLoaded: "".concat(this.ui.cardCount),
            totalCards: "".concat(this.cards.length)
          });
        },
        sortCards: function sortCards() {
          //console.log('hello');
          // sorts based on whatever sort criteria is active in this.ui.sortBy, using whichever direction is set
          var sortOrder = this.ui.sortOrderAsc ? 'asc' : 'desc';

          var sortedArray = _.orderBy(this.cards, [this.ui.sortBy], [sortOrder]);

          this.cards = sortedArray; // overwrite the original object with the sorted array. If we screw it up, we can use this.resetVueCardData()
        },
        // switches between mobile and desktop page sizes
        updatePageSize: function updatePageSize() {
          if (window.matchMedia("(max-width:767px)").matches) {
            this.ui.currentPageSize = this.ui.mobilePageSize;
          } else if (window.matchMedia("(max-width:1024px)").matches) {
            this.ui.currentPageSize = this.ui.tabletPageSize;
          } else {
            this.ui.currentPageSize = this.ui.pageSize;
          } // do not call applyActiveSettings in here or you'll infinite loop

        },
        // abstracted the throttled resize-listener into this specific function, opening it up to do more
        // Jeremy M, 28 Jan 2019
        resizeListener: function resizeListener() {
          if (window.matchMedia("(max-width:767px)").matches) {
            if (this.forceGridViewMobile && this.ui.isGrid == false) {
              this.ui.forcedGrid = true;
              this.ui.isGrid = true;
            } // this.shutFilterDropdown();

          } else {
            // if we forced them, turn it off
            if (this.ui.forcedGrid == true) {
              this.ui.isGrid = false;
              this.ui.forcedGrid = false;
            }
          } // run the sort and filters


          this.applyActiveSettings();
        },
        getTarget: function getTarget(newTab) {
          var targetString = "_self";

          if (newTab) {
            targetString = "_blank";
          }

          return targetString;
        },
        getOpener: function getOpener(newTab) {
          var targetString = "";

          if (newTab) {
            targetString = "noopener";
          }

          return targetString;
        },
        getLink: function getLink(link) {
          if (link === '') {
            return false;
          } else {
            return link;
          }
        },
        getURLFilter: function getURLFilter() {
          var href = window.location.href;
          var rv = null;

          if (href.indexOf("filter=") >= 0) {
            var filterText = href.split('filter=')[1]; // remove any other query string params that may exist after the data

            filterText = filterText.split('/')[0]; // console.log("getURLFilter :: string after / : " + filterText);

            filterText = filterText.split('&')[0]; // console.log("getURLFilter :: string after & : " + filterText);

            filterText = filterText.split('#')[0]; // console.log("getURLFilter :: string after # : " + filterText);

            rv = filterText;
          }

          return rv;
        },
        gtmPush: function gtmPush(gtmObj) {
          if (_typeof(window.dataLayer) == 'object') {
            window.dataLayer.push(gtmObj);
          }
        }
      }
    });
  }
};

},{"embla-carousel":"embla-carousel","jquery-hoverintent":"jquery-hoverintent","lodash":"lodash","vue":"vue"}],31:[function(require,module,exports){
"use strict";

var ui = require('./ui.js');

module.exports = {
  init: function init() {
    this.$tabContainer = $('.tabs');
    this.$tabs = $('.js-tablink');
    this.$tabContentContainer = $('.js-tab-content-container');
    this.data = this.$tabs.data("tab");
    this.tabControls();
    $('.tab-content-container .corner').on('click', function () {
      if ($(this).parent().hasClass('active')) {
        $(this).parent().removeClass('active');
      } else {
        $('.tab-content-container').removeClass('active');
        $(this).parent().addClass('active');
      }
    });
  },
  tabControls: function tabControls() {
    var self = this;

    if (this.$tabContainer.is(':visible')) {
      this.$tabs.on('click', function (e) {
        var dataTab = $(this).data("tab");

        if (!$(this).hasClass('active')) {
          $(this).parent().parent().find('.js-tablink.active').removeClass('active');
          $(this).parent().parent().find('.js-tab-content-container.active').removeClass('active');
          $(this).addClass('active');
          $("#" + dataTab).addClass('active');
        }
      });
    }
  }
};

},{"./ui.js":35}],32:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var lineClamp = require('line-clamp');

module.exports = {
  init: function init() {
    var _this = this;

    // array to hold clamped elemnts and a helper id
    this.clampedElements = [];
    this.nodeID = 0; // the collection of all the clamped elements

    var clampCollective = document.querySelectorAll('.js-clampWrap'); // check the type and length and then loop over the elements
    // Calls the clamping function helper

    if (_typeof(clampCollective) && clampCollective.length > 0) {
      clampCollective.forEach(function (el) {
        _this.textClamp(el);
      }); // Set up event listenters - this is broken
      // $(document).on('test', this.textClampResize(this));
      // $(document).on('test', this.textClampResize(this));
      // $(document).on('test', this.textClampResize(this));

      $(document).on('sizedToMobile', function () {
        _this.textClampResize();
      });
      $(document).on('sizedToTablet', function () {
        _this.textClampResize();
      });
      $(document).on('sizedToDesktop', function () {
        _this.textClampResize();
      });
    }
  },
  // Get the elements id or set one if its missing
  getID: function getID(elem) {
    if (elem.hasAttribute('id') == false || elem.id == '') {
      elem.id = 'clamped-' + ++this.nodeID;
    }

    return elem.id;
  },
  // Function to calcluate the lines and then ccall the clamping library
  textClamp: function textClamp(el) {
    // save the text wrapper and setup a object to keep track of clamped elements
    var textWrapper = el;
    var tempEl = {}; // First check if this is a tweet, there is different content here

    if (textWrapper.classList.contains('tweet__text')) {
      tempEl = {
        'type': 'tweet',
        'tweet_text': textWrapper.innerHTML
      }; // Get the wrapper height and the line height of the tweet content

      var wrapperHeight = textWrapper.clientHeight;
      var contentLineHeight = parseFloat(window.getComputedStyle(textWrapper).getPropertyValue("line-height")); // Calculate the max number of lines that will fit in this space

      var contentLines = Math.floor(wrapperHeight / contentLineHeight); // Clamp the text

      var elementClamp = lineClamp(textWrapper, contentLines); // Save the element to the clamped elements array with the id as a key

      this.clampedElements[this.getID(textWrapper)] = tempEl; // Were done here

      return;
    } // This is for one of the other featured articles
    else {
      // Calculate the height of the wrapper
      var _wrapperHeight = textWrapper.clientHeight; //Attempt to get the heading and content dom elements

      var heading = textWrapper.querySelector('.headline');
      var content = textWrapper.querySelector('.content-preview'); // If there is no heading something is wrong

      if (heading != null) {
        // Update the object 
        tempEl = {
          'type': 'article',
          'headline': heading.innerHTML
        }; // Calculate the the max number of heading lines

        var headingLineHeight = parseFloat(window.getComputedStyle(heading).getPropertyValue("line-height"));
        var headingLines = Math.floor(_wrapperHeight / headingLineHeight); // Clamp the heading

        var _elementClamp = lineClamp(heading, headingLines); // If we have clamped the heading and we have preview content


        if (!_elementClamp && content != null) {
          // Update the object 
          tempEl = {
            'type': 'article',
            'headline': heading.innerHTML,
            'previewContent': content.innerHTML
          }; // Get the preview content line height

          var _contentLineHeight = parseFloat(window.getComputedStyle(content).getPropertyValue("line-height")); // Get the height of the heading


          var headingHeight = heading.clientHeight; // Calculating the number of max number of lines in the remaing space in the wrapper

          var _contentLines = Math.floor((_wrapperHeight - headingHeight) / _contentLineHeight); // clamp the content


          lineClamp(content, _contentLines);
        } // We clamped the heading and we have content
        else if (content != null) {
          // add a class to hide the preview content
          content.classList.add('hide');
          tempEl = {
            'type': 'article',
            'headline': heading.innerHTML,
            'previewContent': content.innerHTML
          };
        }

        this.clampedElements[this.getID(textWrapper)] = tempEl;
      }
    }
  },
  // This function should fire when we change breakpoints and recalculate the line clamping for these elements
  textClampResize: function textClampResize() {
    var _this2 = this;

    console.log('FIRE');
    console.log(this.clampedElements);
    Object.keys(this.clampedElements).forEach(function (id) {
      var el = document.getElementById(id);
      var elObj = _this2.clampedElements[id];

      if (elObj.type == 'tweet') {
        $('.tweet__text').css('visibility', 'hidden');
        $('.tweet__text').html(elObj['tweet_text']);
        setTimeout(function () {
          var wrapperHeight = el.clientHeight;
          var contentLineHeight = parseFloat(window.getComputedStyle(el).getPropertyValue("line-height"));
          var contentLines = Math.floor(wrapperHeight / contentLineHeight);
          var elementClamp = lineClamp(el, contentLines);
          $('.tweet__text').css('visibility', 'visible');
        }, 300);
      } else {
        $('#' + id).css('visibility', 'hidden'); // This probably needs to be its own function were using it in 2 places
        // Time

        var wrapperHeight = el.clientHeight;

        if (elObj['headline'] != null) {
          var heading = el.querySelector('.headline');
          heading.innerHTML = elObj['headline'];
          var elementClamp = false;
          setTimeout(function () {
            // Calculate the the max number of heading lines
            var headingLineHeight = parseFloat(window.getComputedStyle(heading).getPropertyValue("line-height"));
            var headingLines = Math.floor(wrapperHeight / headingLineHeight); // Clamp the heading

            elementClamp = lineClamp(heading, headingLines);
          }, 500);

          if (!elementClamp && elObj['previewContent'] != null) {
            var content = el.querySelector('.content-preview');
            content.innerHTML = elObj['previewContent'];
            setTimeout(function () {
              // Get the preview content line height
              var contentLineHeight = parseFloat(window.getComputedStyle(content).getPropertyValue("line-height")); // Get the height of the heading

              var headingHeight = heading.clientHeight; // Calculating the number of max number of lines in the remaing space in the wrapper

              var contentLines = Math.floor((wrapperHeight - headingHeight) / contentLineHeight); // clamp the content

              lineClamp(content, contentLines);
            }, 500);
          }
        }

        $('#' + id).css('visibility', 'visible');
      }
    });
  }
};

},{"line-clamp":"line-clamp"}],33:[function(require,module,exports){
"use strict";

module.exports = {
  init: function init() {
    $('.box.overlay').on('click', function () {
      if ($(this).hasClass('overlay-active')) {
        $(this).removeClass('overlay-active');
      } else {
        $(this).addClass('overlay-active');
      }
    });
  }
};

},{}],34:[function(require,module,exports){
"use strict";

var textClamp = require('./text-clamp.js');

module.exports = {
  init: function init() {
    var domElement = $('.twitter');
    var configList = {
      "profile": {
        "screenName": "KyowaKirin_US"
      },
      "domId": 'twitter_tweet',
      "maxTweets": 1,
      "enableLinks": true,
      "showUser": false,
      "showTime": false,
      "showImages": true,
      "showInteraction": false,
      "lang": 'en',
      "showPermalinks": true
    };
    var config2 = {
      "profile": {
        "screenName": "KyowaKirin_US"
      },
      "maxTweets": 2,
      "dataOnly": true,
      "showImages": true,
      "customCallback": twitterData
    }; // check for the twitter section before trying to fetch the 

    if (domElement.length) {
      // twitterFetcher.fetch(configList);
      twitterFetcher.fetch(config2);
    }

    function getMonthName(numericMonth) {
      return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][numericMonth];
    }

    function twitterData(tweets) {
      var tweet = tweets[0]; // console.log(tweet);

      if (tweet.permalinkURL != undefined) {
        // clean up the tweettext marking where the long strings are, for mobile text-breaks
        var txt = tweet.tweetText.toString(); // console.log(txt);
        // update the Text
        // wrap words over 10 characters in spans

        var cleanText = txt.replace(/(\b\w{10,})/ig, '<span>$1</span>'); // console.log(cleanText);

        domElement.find(".tweet__text").html(cleanText); // put the permalinkURL into the .js-tweetlink href attribute

        domElement.find('.js-tweet-link').attr('href', tweet.permalinkURL); // add the date

        var parsed = new Date(tweet.timestamp);
        domElement.find(".publish-date").text(parsed.getDate() + " " + getMonthName(parsed.getMonth()) + " " + parsed.getFullYear()); // domElement.wrap("<a href='" + tweet.permalinkURL +"' target='_blank' class='tweet-link'></a>");
        // console.log(domElement.length);
        // update the image if we have one
        // console.log(tweet.image);

        if (typeof tweet.image != 'undefined' && tweet.image.length > 0) {
          domElement.find(".imagebox img").attr('src', tweet.image); // needs a helper CSS class

          domElement.find(".tweet").addClass('has-image');
        }

        var tweetText = document.querySelectorAll('.tweet__text');
        tweetText.forEach(function (el) {
          setTimeout(function () {
            textClamp.textClamp(el);
          }, 300);
        });
      }
    }
  }
};

},{"./text-clamp.js":32}],35:[function(require,module,exports){
"use strict";

var _ = require('lodash');

var tabbedContent = require('./tabbed-component.js');

var textClamp = require('./text-clamp.js');

var twitterConfig = require('./twitter-config.js');

var UIService = {
  /**
   * Use this for global UI events, calulations etc
   */
  init: function init() {
    var _this = this;

    // Set up some variables
    this.$window = $(window);
    this.$body = $('body');
    this.mobileMediaQuery = "( max-width: 767px )";
    this.tabletMediaQuery = "( max-width: 1023px )";
    this.isMobile = false;
    this.isTablet = false;
    this.tabletClass = 'isTablet';
    this.mobileClass = 'isMobile';
    this.touchInputClass = 'touchInput';
    this.freeze = false;
    this.scrollTop = 0;
    this.currentSize = ""; // Get the display size

    this.displaySize(); // Detect touch y'all

    this.detectTouch();
    this.getOS();
    this.getBrowser();
    /** A debounced resize function */

    var debouncedResize = _.throttle(function () {
      _this.resize();
    }, 50); // call the debounced function on resize


    this.$window.resize(function () {
      debouncedResize();
    });
    /** A debounced scroll function */

    var debouncedScroll = _.throttle(function () {
      _this.scroll();
    }, 50); // call the debounced function on resize


    this.$window.scroll(function () {
      debouncedScroll();
    });
  },

  /**
   * Resize triggers go here, this should be debounced in init
   */
  resize: function resize() {
    // Detect if we've hit a display threshold (to/from destop/mobile) and detect the actual size
    this.displayDetection();
    tabbedContent.tabControls();
  },

  /**
   * Scroll triggers go here, this should be debounced in init
   */
  scroll: function scroll() {
    // Probably ISI and sticky header stuff, once we make those
    if ($(window).scrollTop() >= 20) {
      $('.navbar-bottom').addClass('fade').fadeOut(500);
    } else {
      $('.navbar-bottom').removeClass('fade').fadeIn(500);
    }
  },

  /**
   * Detects a touch event and add a class to the body, used in conjunction with screen size
   * detection, we should be able to infer mobile devices
   * @author Rob Szpila <robert@arteric.com>
   */
  detectTouch: function detectTouch() {
    var _this2 = this;

    /** A touch event listener that removes itself */
    $(document).one('touchstart', function () {
      _this2.$body.addClass(_this2.touchInputClass);
    });
  },

  /**
   * Using handy matchMeda we can be super accurate in JS about media queries...horray for parity
   * called from displayDetection on resize
   * @author Rob Szpila <robert@arteric.com>
   */
  displaySize: function displaySize() {
    if (window.matchMedia(this.mobileMediaQuery).matches) {
      // We're totally not tablet...definitely
      this.isTablet = false;
      this.$body.removeClass(this.tabletClass); // We're mobile!

      this.isMobile = true;
      this.$body.addClass(this.mobileClass);
    } else if (window.matchMedia(this.tabletMediaQuery).matches) {
      // We're totally not mobile...probably
      this.isMobile = false;
      this.$body.removeClass(this.mobileClass); // We're TABLET!

      this.isTablet = true;
      this.$body.addClass(this.tabletClass); // $( document ).trigger( 'sizedToTablet' );
    } else if (!window.matchMedia(this.mobileMediaQuery).matches && !window.matchMedia(this.tabletMediaQuery).matches) {
      // We're nothing
      this.isTablet = false;
      this.isMobile = false;
      this.$body.removeClass(this.mobileClass).removeClass(this.tabletClass);
    }
  },

  /**
   * Emit a thing when we cross display thresholds
   */
  displayDetection: function displayDetection() {
    var wasLargeView = !this.isTablet && !this.isMobile; // Get the display size

    this.displaySize(); // console.log(this.currentSize);
    // If we just changed down to tablet or mobile, lets get the user to where they were

    if (this.currentSize != "mobile" && this.isMobile) {
      // Let's emit an event, because this is handy
      $(document).trigger('sizedToMobile');
      this.currentSize = "mobile";
      console.log('sized to mobile');
    } else if (this.currentSize != "tablet" && this.isTablet) {
      $(document).trigger('sizedToTablet');
      this.currentSize = "tablet";
      console.log('sized to tablet');
    } // If we just changed up, emit an event
    else if (this.currentSize != "desktop" && !this.isTablet && !this.isMobile) {
      $(document).trigger('sizedToDesktop');
      this.currentSize = "desktop";
      console.log('sized to desktop');
    }
  },

  /**
   * Check if we're at tablet or lower and set the body to fixed and preserve scroll
   * @author Rob Szpila <robert@arteric.com>
   */
  freezeScroll: function freezeScroll() {
    this.scrollTop = $(window).scrollTop();
    this.$body.addClass('fixed');
    this.$body.css('top', this.scrollTop * -1);
  },

  /**
   * Check if the scroll is frozen and unfreeze
   * @author Rob Szpila <robert@arteric.com>
   */
  unFreezeScroll: function unFreezeScroll() {
    if (this.$body.hasClass('fixed')) {
      this.$body.removeClass('fixed');
      this.$body.css('top', 'auto');
      $(window).scrollTop(this.scrollTop);
    }
  },
  getOS: function getOS() {
    var userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'];

    if (macosPlatforms.indexOf(platform) !== -1) {
      this.os = 'MacOS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      this.os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      this.os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      this.os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      this.os = 'Linux';
    }

    $('body').addClass(this.os);
  },
  getBrowser: function getBrowser() {
    // Get the user-agent string 
    var userAgentString = navigator.userAgent; // Detect Chrome 

    var chromeAgent = userAgentString.indexOf("Chrome") > -1; // Detect Internet Explorer 

    var IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1; // Detect Firefox 

    var firefoxAgent = userAgentString.indexOf("Firefox") > -1; // Detect Safari 

    var safariAgent = userAgentString.indexOf("Safari") > -1; // Discard Safari since it also matches Chrome 

    if (chromeAgent && safariAgent) safariAgent = false; // Detect Opera 

    var operaAgent = userAgentString.indexOf("OP") > -1; // Discard Chrome since it also matches Opera      

    if (chromeAgent && operaAgent) chromeAgent = false;

    if (chromeAgent) {
      $('body').addClass('chrome');
    }

    if (IExplorerAgent) {
      $('body').addClass('ie');
    }

    if (firefoxAgent) {
      $('body').addClass('firefox');
    }

    if (safariAgent) {
      $('body').addClass('safari');
    }

    if (operaAgent) {
      $('body').addClass('opera');
    }
  }
};
module.exports = UIService;
window.UIService = UIService;

},{"./tabbed-component.js":31,"./text-clamp.js":32,"./twitter-config.js":34,"lodash":"lodash"}],36:[function(require,module,exports){
"use strict";

jQuery.extend(jQuery.easing, {
  def: 'easeOutQuad',
  easeInQuad: function easeInQuad(x, t, b, c, d) {
    return c * (t /= d) * t + b;
  },
  easeOutQuad: function easeOutQuad(x, t, b, c, d) {
    return -c * (t /= d) * (t - 2) + b;
  },
  easeInOutQuad: function easeInOutQuad(x, t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t + b;
    return -c / 2 * (--t * (t - 2) - 1) + b;
  },
  easeInCubic: function easeInCubic(x, t, b, c, d) {
    return c * (t /= d) * t * t + b;
  },
  easeOutCubic: function easeOutCubic(x, t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
  },
  easeInOutCubic: function easeInOutCubic(x, t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
    return c / 2 * ((t -= 2) * t * t + 2) + b;
  },
  easeInQuart: function easeInQuart(x, t, b, c, d) {
    return c * (t /= d) * t * t * t + b;
  },
  easeOutQuart: function easeOutQuart(x, t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
  },
  easeInOutQuart: function easeInOutQuart(x, t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
  },
  easeInQuint: function easeInQuint(x, t, b, c, d) {
    return c * (t /= d) * t * t * t * t + b;
  },
  easeOutQuint: function easeOutQuint(x, t, b, c, d) {
    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
  },
  easeInOutQuint: function easeInOutQuint(x, t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
    return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
  },
  easeInSine: function easeInSine(x, t, b, c, d) {
    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
  },
  easeOutSine: function easeOutSine(x, t, b, c, d) {
    return c * Math.sin(t / d * (Math.PI / 2)) + b;
  },
  easeInOutSine: function easeInOutSine(x, t, b, c, d) {
    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
  },
  easeInExpo: function easeInExpo(x, t, b, c, d) {
    return t == 0 ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
  },
  easeOutExpo: function easeOutExpo(x, t, b, c, d) {
    return t == d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
  },
  easeInOutExpo: function easeInOutExpo(x, t, b, c, d) {
    if (t == 0) return b;
    if (t == d) return b + c;
    if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
    return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
  },
  easeInCirc: function easeInCirc(x, t, b, c, d) {
    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
  },
  easeOutCirc: function easeOutCirc(x, t, b, c, d) {
    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
  },
  easeInOutCirc: function easeInOutCirc(x, t, b, c, d) {
    if ((t /= d / 2) < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
    return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
  },
  easeInElastic: function easeInElastic(x, t, b, c, d) {
    var s = 1.70158;
    var p = 0;
    var a = c;
    if (t == 0) return b;
    if ((t /= d) == 1) return b + c;
    if (!p) p = d * .3;

    if (a < Math.abs(c)) {
      a = c;
      var s = p / 4;
    } else var s = p / (2 * Math.PI) * Math.asin(c / a);

    return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
  },
  easeOutElastic: function easeOutElastic(x, t, b, c, d) {
    var s = 1.70158;
    var p = 0;
    var a = c;
    if (t == 0) return b;
    if ((t /= d) == 1) return b + c;
    if (!p) p = d * .3;

    if (a < Math.abs(c)) {
      a = c;
      var s = p / 4;
    } else var s = p / (2 * Math.PI) * Math.asin(c / a);

    return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
  },
  easeInOutElastic: function easeInOutElastic(x, t, b, c, d) {
    var s = 1.70158;
    var p = 0;
    var a = c;
    if (t == 0) return b;
    if ((t /= d / 2) == 2) return b + c;
    if (!p) p = d * (.3 * 1.5);

    if (a < Math.abs(c)) {
      a = c;
      var s = p / 4;
    } else var s = p / (2 * Math.PI) * Math.asin(c / a);

    if (t < 1) return -.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * .5 + c + b;
  },
  easeInBack: function easeInBack(x, t, b, c, d, s) {
    if (s == undefined) s = 1.70158;
    return c * (t /= d) * t * ((s + 1) * t - s) + b;
  },
  easeOutBack: function easeOutBack(x, t, b, c, d, s) {
    if (s == undefined) s = 1.70158;
    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
  },
  easeInOutBack: function easeInOutBack(x, t, b, c, d, s) {
    if (s == undefined) s = 1.70158;
    if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
    return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
  },
  easeInBounce: function easeInBounce(x, t, b, c, d) {
    return c - jQuery.easing.easeOutBounce(x, d - t, 0, c, d) + b;
  },
  easeOutBounce: function easeOutBounce(x, t, b, c, d) {
    if ((t /= d) < 1 / 2.75) {
      return c * (7.5625 * t * t) + b;
    } else if (t < 2 / 2.75) {
      return c * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + b;
    } else if (t < 2.5 / 2.75) {
      return c * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + b;
    } else {
      return c * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + b;
    }
  },
  easeInOutBounce: function easeInOutBounce(x, t, b, c, d) {
    if (t < d / 2) return jQuery.easing.easeInBounce(x, t * 2, 0, c, d) * .5 + b;
    return jQuery.easing.easeOutBounce(x, t * 2 - d, 0, c, d) * .5 + c * .5 + b;
  }
});

},{}],37:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*********************************************************************
*  #### Twitter Post Fetcher v18.0.4 ####
*  Coded by Jason Mayes 2015. A present to all the developers out there.
*  www.jasonmayes.com
*  Please keep this disclaimer with my code if you use it. Thanks. :-)
*  Got feedback or questions, ask here:
*  http://www.jasonmayes.com/projects/twitterApi/
*  Github: https://github.com/jasonmayes/Twitter-Post-Fetcher
*  Updates will be posted to this site.
*********************************************************************/
!function (e, t) {
  "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = t() : t();
}(0, function () {
  var e = "",
      t = 20,
      i = !0,
      n = [],
      a = !1,
      l = !0,
      s = !0,
      r = null,
      o = !0,
      c = !0,
      m = null,
      d = !0,
      p = !1,
      u = !1,
      g = !0,
      h = !0,
      w = !1,
      f = null;

  function b(e) {
    return e.replace(/<b[^>]*>(.*?)<\/b>/gi, function (e, t) {
      return t;
    }).replace(/class="(?!(tco-hidden|tco-display|tco-ellipsis))+.*?"|data-query-source=".*?"|dir=".*?"|rel=".*?"/gi, "");
  }

  function v(e) {
    for (var t = e.getElementsByTagName("a"), i = t.length - 1; i >= 0; i--) {
      t[i].setAttribute("target", "_blank"), t[i].setAttribute("rel", "noopener");
    }
  }

  function _(e, t) {
    for (var i = [], n = new RegExp("(^| )" + t + "( |$)"), a = e.getElementsByTagName("*"), l = 0, s = a.length; l < s; l++) {
      n.test(a[l].className) && i.push(a[l]);
    }

    return i;
  }

  function y(e) {
    if (void 0 !== e && e.innerHTML.indexOf("data-image") >= 0) {
      for (var t = e.innerHTML.match(/data-image=\"([^"]+)\"/gi), i = 0; i < t.length; i++) {
        t[i] = t[i].match(/data-image=\"([^"]+)\"/i)[1], t[i] = decodeURIComponent(t[i]) + ".jpg";
      }

      return t;
    }
  }

  var T = {
    fetch: function fetch(o) {
      if (void 0 === o.maxTweets && (o.maxTweets = 20), void 0 === o.enableLinks && (o.enableLinks = !0), void 0 === o.showUser && (o.showUser = !0), void 0 === o.showTime && (o.showTime = !0), void 0 === o.dateFunction && (o.dateFunction = "default"), void 0 === o.showRetweet && (o.showRetweet = !0), void 0 === o.customCallback && (o.customCallback = null), void 0 === o.showInteraction && (o.showInteraction = !0), void 0 === o.showImages && (o.showImages = !1), void 0 === o.useEmoji && (o.useEmoji = !1), void 0 === o.linksInNewWindow && (o.linksInNewWindow = !0), void 0 === o.showPermalinks && (o.showPermalinks = !0), void 0 === o.dataOnly && (o.dataOnly = !1), a) n.push(o);else {
        a = !0, e = o.domId, t = o.maxTweets, i = o.enableLinks, s = o.showUser, l = o.showTime, c = o.showRetweet, r = o.dateFunction, m = o.customCallback, d = o.showInteraction, p = o.showImages, u = o.useEmoji, g = o.linksInNewWindow, h = o.showPermalinks, w = o.dataOnly;
        var b = document.getElementsByTagName("head")[0];
        null !== f && b.removeChild(f), (f = document.createElement("script")).type = "text/javascript", void 0 !== o.list ? f.src = "https://syndication.twitter.com/timeline/list?callback=__twttrf.callback&dnt=false&list_slug=" + o.list.listSlug + "&screen_name=" + o.list.screenName + "&suppress_response_codes=true&lang=" + (o.lang || "en") + "&rnd=" + Math.random() : void 0 !== o.profile ? f.src = "https://syndication.twitter.com/timeline/profile?callback=__twttrf.callback&dnt=false&screen_name=" + o.profile.screenName + "&suppress_response_codes=true&lang=" + (o.lang || "en") + "&rnd=" + Math.random() : void 0 !== o.likes ? f.src = "https://syndication.twitter.com/timeline/likes?callback=__twttrf.callback&dnt=false&screen_name=" + o.likes.screenName + "&suppress_response_codes=true&lang=" + (o.lang || "en") + "&rnd=" + Math.random() : void 0 !== o.collection ? f.src = "https://syndication.twitter.com/timeline/collection?callback=__twttrf.callback&dnt=false&collection_id=" + o.collection.collectionId + "&suppress_response_codes=true&lang=" + (o.lang || "en") + "&rnd=" + Math.random() : f.src = "https://cdn.syndication.twimg.com/widgets/timelines/" + o.id + "?&lang=" + (o.lang || "en") + "&callback=__twttrf.callback&suppress_response_codes=true&rnd=" + Math.random(), b.appendChild(f);
      }
    },
    callback: function callback(f) {
      if (void 0 === f || void 0 === f.body) return a = !1, void (n.length > 0 && (T.fetch(n[0]), n.splice(0, 1)));
      u || (f.body = f.body.replace(/(<img[^c]*class="Emoji[^>]*>)|(<img[^c]*class="u-block[^>]*>)/g, "")), p || (f.body = f.body.replace(/(<img[^c]*class="NaturalImage-image[^>]*>|(<img[^c]*class="CroppedImage-image[^>]*>))/g, "")), s || (f.body = f.body.replace(/(<img[^c]*class="Avatar"[^>]*>)/g, ""));
      var k = document.createElement("div");

      function C(e) {
        var t = e.getElementsByTagName("img")[0];
        if (t) t.src = t.getAttribute("data-src-2x");else {
          var i = e.getElementsByTagName("a")[0].getAttribute("href").split("twitter.com/")[1],
              n = document.createElement("img");
          n.setAttribute("src", "https://twitter.com/" + i + "/profile_image?size=bigger"), e.prepend(n);
        }
        return e;
      }

      k.innerHTML = f.body, void 0 === k.getElementsByClassName && (o = !1);
      var E = [],
          x = [],
          N = [],
          A = [],
          B = [],
          I = [],
          M = [],
          L = 0;
      if (o) for (var j = k.getElementsByClassName("timeline-Tweet"); L < j.length;) {
        j[L].getElementsByClassName("timeline-Tweet-retweetCredit").length > 0 ? B.push(!0) : B.push(!1), (!B[L] || B[L] && c) && (E.push(j[L].getElementsByClassName("timeline-Tweet-text")[0]), I.push(j[L].getAttribute("data-tweet-id")), s && x.push(C(j[L].getElementsByClassName("timeline-Tweet-author")[0])), N.push(j[L].getElementsByClassName("dt-updated")[0]), M.push(j[L].getElementsByClassName("timeline-Tweet-timestamp")[0]), void 0 !== j[L].getElementsByClassName("timeline-Tweet-media")[0] ? A.push(j[L].getElementsByClassName("timeline-Tweet-media")[0]) : A.push(void 0)), L++;
      } else for (j = _(k, "timeline-Tweet"); L < j.length;) {
        _(j[L], "timeline-Tweet-retweetCredit").length > 0 ? B.push(!0) : B.push(!1), (!B[L] || B[L] && c) && (E.push(_(j[L], "timeline-Tweet-text")[0]), I.push(j[L].getAttribute("data-tweet-id")), s && x.push(C(_(j[L], "timeline-Tweet-author")[0])), N.push(_(j[L], "dt-updated")[0]), M.push(_(j[L], "timeline-Tweet-timestamp")[0]), void 0 !== _(j[L], "timeline-Tweet-media")[0] ? A.push(_(j[L], "timeline-Tweet-media")[0]) : A.push(void 0)), L++;
      }
      E.length > t && (E.splice(t, E.length - t), x.splice(t, x.length - t), N.splice(t, N.length - t), B.splice(t, B.length - t), A.splice(t, A.length - t), M.splice(t, M.length - t));
      var H = [],
          P = (L = E.length, 0);
      if (w) for (; P < L;) {
        H.push({
          tweet: E[P].innerHTML,
          tweetText: E[P].textContent,
          author: x[P] ? x[P].innerHTML : "Unknown Author",
          author_data: {
            profile_url: x[P] ? x[P].querySelector('[data-scribe="element:user_link"]').href : null,
            profile_image: x[P] ? "https://twitter.com/" + x[P].querySelector('[data-scribe="element:screen_name"]').title.split("@")[1] + "/profile_image?size=bigger" : null,
            profile_image_2x: x[P] ? "https://twitter.com/" + x[P].querySelector('[data-scribe="element:screen_name"]').title.split("@")[1] + "/profile_image?size=original" : null,
            screen_name: x[P] ? x[P].querySelector('[data-scribe="element:screen_name"]').title : null,
            name: x[P] ? x[P].querySelector('[data-scribe="element:name"]').title : null
          },
          time: N[P].textContent,
          timestamp: N[P].getAttribute("datetime").replace("+0000", "Z").replace(/([\+\-])(\d\d)(\d\d)/, "$1$2:$3"),
          image: y(A[P]) ? y(A[P])[0] : void 0,
          images: y(A[P]),
          rt: B[P],
          tid: I[P],
          permalinkURL: void 0 === M[P] ? "" : M[P].href
        }), P++;
      } else for (; P < L;) {
        if ("string" != typeof r) {
          var R = N[P].getAttribute("datetime"),
              F = new Date(N[P].getAttribute("datetime").replace(/-/g, "/").replace("T", " ").split("+")[0]),
              S = r(F, R);
          if (N[P].setAttribute("aria-label", S), E[P].textContent) {
            if (o) N[P].textContent = S;else {
              var q = document.createElement("p"),
                  O = document.createTextNode(S);
              q.appendChild(O), q.setAttribute("aria-label", S), N[P] = q;
            }
          } else N[P].textContent = S;
        }

        var U = "";
        if (i ? (g && (v(E[P]), s && v(x[P])), s && (U += '<div class="user">' + b(x[P].innerHTML) + "</div>"), U += '<p class="tweet">' + b(E[P].innerHTML) + "</p>", l && (U += h ? '<p class="timePosted"><a href="' + M[P] + '">' + N[P].getAttribute("aria-label") + "</a></p>" : '<p class="timePosted">' + N[P].getAttribute("aria-label") + "</p>")) : (E[P].textContent, s && (U += '<p class="user">' + x[P].textContent + "</p>"), U += '<p class="tweet">' + E[P].textContent + "</p>", l && (U += '<p class="timePosted">' + N[P].textContent + "</p>")), d && (U += '<p class="interact"><a href="https://twitter.com/intent/tweet?in_reply_to=' + I[P] + '" class="twitter_reply_icon"' + (g ? ' target="_blank" rel="noopener">' : ">") + 'Reply</a><a href="https://twitter.com/intent/retweet?tweet_id=' + I[P] + '" class="twitter_retweet_icon"' + (g ? ' target="_blank" rel="noopener">' : ">") + 'Retweet</a><a href="https://twitter.com/intent/favorite?tweet_id=' + I[P] + '" class="twitter_fav_icon"' + (g ? ' target="_blank" rel="noopener">' : ">") + "Favorite</a></p>"), p && void 0 !== A[P] && void 0 !== y(A[P])) for (var D = y(A[P]), $ = 0; $ < D.length; $++) {
          U += '<div class="media"><img src="' + D[$] + '" alt="Image from tweet" /></div>';
        }
        p ? H.push(U) : !p && E[P].textContent.length && H.push(U), P++;
      }
      !function (t) {
        if (null === m) {
          for (var i = t.length, n = 0, a = document.getElementById(e), l = "<ul>"; n < i;) {
            l += "<li>" + t[n] + "</li>", n++;
          }

          l += "</ul>", a.innerHTML = l;
        } else m(t);
      }(H), a = !1, n.length > 0 && (T.fetch(n[0]), n.splice(0, 1));
    }
  };
  return window.__twttrf = T, window.twitterFetcher = T, T;
}), [Element.prototype, Document.prototype, DocumentFragment.prototype].forEach(function (e) {
  e.hasOwnProperty("prepend") || Object.defineProperty(e, "prepend", {
    configurable: !0,
    enumerable: !0,
    writable: !0,
    value: function value() {
      var e = Array.prototype.slice.call(arguments),
          t = document.createDocumentFragment();
      e.forEach(function (e) {
        var i = e instanceof Node;
        t.appendChild(i ? e : document.createTextNode(String(e)));
      }), this.insertBefore(t, this.firstChild);
    }
  });
});

},{}],38:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var $ = window.jQuery;

var ui = require("./ui");

var _ = require('lodash');

var remodal = require('remodal');

module.exports = {
  init: function init() {
    // Declare Variables
    this.$videoAnchors = $('.remodal-video');
    this.$modalVideoElement = $('[data-remodal-id=video-modal]');
    this.$videoEmbed = $('.remodal-embed'); // this.makeModal( this.$videoAnchors, this.$modalVideoElement, this.$videoEmbed );

    var self = this; // This bind event will cover video modals that are laoded after init

    $(document).on("click", '.remodal-video', function () {
      self.makeModal($(this), self.$modalVideoElement, self.$videoEmbed);
    });
  },
  makeModal: function makeModal($el, $videoElement, $embed) {
    // Create Video Modal
    var $src = $el.attr('data-link'); // $src = $src.replace('watch?v=', 'embed/');

    ui.freezeScroll();
    $videoElement.css('display', 'block');
    var $video = $videoElement.remodal(); // This code seems kind of overblown, but this is for GTM support
    // We clone the element, clear out GTM added attributes, set the source, and recreate the iframe entirely
    // Then we need to update the object's videoEmbed var to make sure everything works
    // This is so GTM can properly rehook video events

    var $embedClone = $embed.clone();
    this.removeYTAttribute($embedClone);
    $embedClone.attr('src', $src);
    $embed.replaceWith($embedClone);
    $embed = $embedClone;
    this.$videoEmbed = $('.remodal-embed'); // Also pop open the modal after

    $video.open();

    if (ui.isMobile) {
      $embed.css('width', '300px');
      $embed.css('height', '188px');
    } else if (ui.isTablet) {
      $embed.css('width', '720px');
      $embed.css('height', '450px');
    } else {
      $embed.css('width', '964px');
      $embed.css('height', '603px');
    }

    this.listenForResize($embed, $videoElement);
    $(document).on('closing', $video, function () {
      ui.unFreezeScroll();
      $embed.each(function () {
        console.log($(this));
        $(this).attr('src', '');
      });
    });
  },
  listenForResize: function listenForResize($embed, $videoElement) {
    var throttledModalSize = _.throttle(function () {
      if (ui.isMobile) {
        $embed.css('width', '300px');
        $embed.css('height', '188px');
        $videoElement.css('width', '300px');
        $videoElement.css('height', '188px');
      } else if (ui.isTablet) {
        $embed.css('width', '720px');
        $embed.css('height', '450px');
        $videoElement.css('width', '720px');
        $videoElement.css('height', '450px');
      } else {
        $embed.css('width', '964px');
        $embed.css('height', '603px');
        $videoElement.css('width', '964px');
        $videoElement.css('height', '603px');
      }
    }, 300);

    $(window).resize(throttledModalSize);
  },
  removeYTAttribute: function removeYTAttribute($embed) {
    // get the native attributes object
    var attrs = $embed[0].attributes;
    var toRemove = []; // cache the jquery object containing the element for better performance
    // iterate the attributes

    for (var index = 0; index <= attrs.length; index++) {
      if (_typeof(attrs[index]) === 'object' && typeof attrs[index].name === 'string' && /^data-gtm-yt-inspected/.test(attrs[index].name)) {
        // Unfortunately, we can not call removeAttr directly in here, since it
        // hurts the iteration.
        toRemove.push(attrs[index].name);
      }
    }

    for (var i = 0; i < toRemove.length; i++) {
      $embed.removeAttr(toRemove[i]);
    }
  }
};

},{"./ui":35,"lodash":"lodash","remodal":"remodal"}],39:[function(require,module,exports){
"use strict";

var ui = require('./ui.js');

var hoverIntent = require('jquery-hoverintent');

module.exports = {
  init: function init() {
    $('#our-core-values .component-large-image-with-expandable-ctas .shape').on('click', function () {
      if (ui.isMobile == true || ui.isTablet == true) {
        $('.component-large-image-with-expandable-ctas .shape').not(this).removeClass('active');

        if ($(this).hasClass('active')) {
          $(this).removeClass('active');
        } else {
          $(this).addClass('active');
        }
      }
    });
    $("#our-core-values .component-large-image-with-expandable-ctas .shape").hoverIntent(function () {
      if (ui.isMobile == false && ui.isTablet == false) {
        $('.component-large-image-with-expandable-ctas .shape').not(this).removeClass('active');
        $(this).addClass('active');
      }
    }, function () {
      if (ui.isMobile == false && ui.isTablet == false) {
        $('.component-large-image-with-expandable-ctas .shape').not(this).removeClass('active');
        $(this).removeClass('active');
      }
    });
  }
};

},{"./ui.js":35,"jquery-hoverintent":"jquery-hoverintent"}]},{},[15]);
